// components/ActionBar.tsx
import styles6 from "./ActionBar.module-TN4RQQF5.module.css";
import * as React10 from "react";

// components/ButtonGroup.tsx
import styles5 from "./ButtonGroup.module-4LFCRCIW.module.css";

// common/utilities.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
var hasOwn = {}.hasOwnProperty;
var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
function noop() {
  return null;
}
function pluralize(text, count) {
  return count > 1 || count === 0 ? `${text}s` : text;
}
function getOrdinalNumber(n) {
  return n + (n > 0 ? ["th", "st", "nd", "rd"][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
}
function deepEqual(x, y) {
  return x && y && typeof x === "object" && typeof y === "object" ? Object.keys(x).length === Object.keys(y).length && //@ts-ignore
  Object.keys(x).reduce(
    (isEqual, key) => isEqual && deepEqual(x[key], y[key]),
    true
  ) : x === y;
}
function getDomainFromEmailWithoutAnySubdomain(email) {
  const atIndex = email.lastIndexOf("@");
  if (atIndex === -1) {
    return "";
  }
  const domain = email.slice(atIndex + 1);
  const domainParts = domain.split(".");
  if (domainParts.length < 2) {
    return "";
  }
  const mainDomain = domainParts.slice(-2).join(".");
  return mainDomain;
}
function onHandleThemeChange(className) {
  const body = document.body;
  body.classList.forEach((existingClass) => {
    if (existingClass.startsWith("theme-")) {
      body.classList.remove(existingClass);
    }
  });
  if (className) {
    body.classList.add(className);
  } else {
    body.classList.add("theme-light");
  }
}
function onHandleFontChange(className) {
  const body = document.body;
  if (className) {
    body.classList.forEach((existingClass) => {
      if (existingClass.startsWith("font-")) {
        body.classList.remove(existingClass);
      }
    });
    body.classList.add(className);
    return;
  }
  body.classList.forEach((existingClass) => {
    if (existingClass.startsWith("font-")) {
      body.classList.remove(existingClass);
    }
  });
}
function formatDollars(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(value);
}
function calculatePositionWithGutter(rect, objectWidth, viewportWidth, gutter = 24) {
  const right = viewportWidth - rect.right;
  const top = rect.top + rect.height + gutter;
  const side = right + objectWidth >= viewportWidth ? "left" : "right";
  const adjustedRight = side === "left" ? viewportWidth - objectWidth - gutter : right;
  return { top, right: adjustedRight, side };
}
function calculatePositionWithGutterById(id, objectWidth, viewportWidth, gutter) {
  let rect;
  if (id) {
    const el = document.getElementById(id);
    if (el) {
      rect = el.getBoundingClientRect();
    }
  }
  return calculatePositionWithGutter(rect, objectWidth, viewportWidth, gutter);
}
function leftPad(input, length) {
  const zerosNeeded = length - input.length;
  if (zerosNeeded <= 0) {
    return input;
  }
  const zeros = "0".repeat(zerosNeeded);
  return zeros + input;
}
function toDateISOString(data) {
  const date = new Date(data);
  const dayOfWeek = date.toLocaleDateString("en-US", {
    weekday: "long"
  });
  const month = date.toLocaleDateString("en-US", {
    month: "long"
  });
  const dayOfMonth = getOrdinalNumber(date.getDate());
  const year = date.getFullYear();
  const formattedDate = `${dayOfWeek}, ${month} ${dayOfMonth}, ${year}`;
  return formattedDate;
}
function elide(string, length = 140, emptyState = "...") {
  if (isEmpty(string)) {
    return emptyState;
  }
  if (string.length < length) {
    return string.trim();
  }
  return `${string.substring(0, length)}...`;
}
function bytesToSize(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1e3;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / k ** i).toFixed(dm)} ${sizes[i]}`;
}
function isEmpty(text) {
  if (text === 0) {
    return false;
  }
  if (!text) {
    return true;
  }
  if (typeof text === "object") {
    return true;
  }
  if (text.length === 0) {
    return true;
  }
  text = text.toString();
  return Boolean(!text.trim());
}
function createSlug(text) {
  if (isEmpty(text)) {
    return "untitled";
  }
  const a = "\xE6\xF8\xE5\xE0\xE1\xE4\xE2\xE8\xE9\xEB\xEA\xEC\xED\xEF\xEE\xF2\xF3\xF6\xF4\xF9\xFA\xFC\xFB\xF1\xE7\xDF\xFF\u0153\xE6\u0155\u015B\u0144\u1E55\u1E83\u01F5\u01F9\u1E3F\u01D8\u1E8D\u017A\u1E27\xB7/_,:;";
  const b = "aoaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------";
  const p = new RegExp(a.split("").join("|"), "g");
  return text.toString().toLowerCase().replace(/\s+/g, "-").replace(p, (c) => b.charAt(a.indexOf(c))).replace(/&/g, "-and-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
}
function isUrl(string) {
  if (typeof string !== "string") {
    return false;
  }
  const match = string.match(protocolAndDomainRE);
  if (!match) {
    return false;
  }
  const everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }
  if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
    return true;
  }
  return false;
}
function debounce(fn, delay) {
  let timeoutID;
  let lastArgs;
  const run = () => {
    if (lastArgs) {
      fn(...lastArgs);
      lastArgs = void 0;
    }
  };
  const debounced = (...args) => {
    clearTimeout(timeoutID);
    lastArgs = args;
    timeoutID = window.setTimeout(run, delay);
  };
  debounced.flush = () => {
    clearTimeout(timeoutID);
  };
  return debounced;
}
function timeAgo(dateInput) {
  const date = new Date(dateInput);
  const now = /* @__PURE__ */ new Date();
  const secondsPast = (now.getTime() - date.getTime()) / 1e3;
  if (secondsPast < 0 || Number.isNaN(secondsPast)) {
    return "[INVALID]";
  }
  if (secondsPast < 60) {
    return "Just now";
  }
  if (secondsPast < 3600) {
    const minutes = Math.floor(secondsPast / 60);
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  }
  if (secondsPast < 86400) {
    const hours = Math.floor(secondsPast / 3600);
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  }
  if (secondsPast < 604800) {
    const days = Math.floor(secondsPast / 86400);
    return `${days} day${days > 1 ? "s" : ""} ago`;
  }
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  });
  return formattedDate;
}
function classNames(...args) {
  const classes = [];
  for (let i = 0; i < arguments.length; i++) {
    const arg = arguments[i];
    if (!arg) continue;
    const argType = typeof arg;
    if (argType === "string" || argType === "number") {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      if (arg.length) {
        const inner = classNames.apply(null, arg);
        if (inner) {
          classes.push(inner);
        }
      }
    } else if (argType === "object") {
      if (arg.toString !== Object.prototype.toString) {
        classes.push(arg.toString());
      } else {
        for (const key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }
  }
  return classes.join(" ");
}
async function generateNonce() {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < 8; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
function filterUndefined(obj) {
  const res = {};
  Object.keys(obj).filter((k) => obj[k] !== void 0).forEach((k) => res[k] = obj[k]);
  return res;
}
var isFocusableElement = (element) => {
  if (!element || !(element instanceof HTMLElement)) {
    return false;
  }
  const focusableSelectors = [
    "a[href]",
    "button",
    "input",
    "select",
    "textarea",
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ];
  return element.matches(focusableSelectors.join(", "));
};
var findNextFocusable = (element, direction = "next") => {
  if (!element) return null;
  const focusableSelectors = [
    "a[href]",
    "button",
    "input",
    "select",
    "textarea",
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ];
  const focusableElements = Array.from(
    document.querySelectorAll(focusableSelectors.join(", "))
  );
  const currentIndex = focusableElements.indexOf(element);
  if (currentIndex !== -1) {
    const nextIndex = direction === "next" ? (currentIndex + 1) % focusableElements.length : (currentIndex - 1 + focusableElements.length) % focusableElements.length;
    return focusableElements[nextIndex];
  }
  return null;
};
var findFocusableDescendant = (container, currentFocused = null, direction = "next") => {
  if (!container) return null;
  const focusableElements = Array.from(
    container.querySelectorAll(
      'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]'
    )
  );
  if (focusableElements.length === 0) return null;
  let index = 0;
  if (currentFocused) {
    const currentIndex = focusableElements.indexOf(
      currentFocused
    );
    if (currentIndex !== -1) {
      index = direction === "next" ? currentIndex + 1 : currentIndex - 1;
    }
  }
  if (index >= 0 && index < focusableElements.length) {
    return focusableElements[index];
  }
  return null;
};

// components/ButtonGroup.tsx
import * as React9 from "react";

// components/ActionButton.tsx
import styles from "./ActionButton.module-C7R7TGBA.module.css";
import * as React2 from "react";
var ActionButton = React2.forwardRef(
  ({ onClick, hotkey, children, style, rootStyle, active, disabled }, ref) => {
    return /* @__PURE__ */ React2.createElement(
      "div",
      {
        className: cn(
          styles.root,
          active ? styles.selected : null,
          disabled ? styles.disabled : null
        ),
        style: rootStyle,
        onClick: disabled ? void 0 : onClick,
        tabIndex: disabled ? -1 : 0,
        ref,
        role: "button",
        "aria-disabled": disabled
      },
      isEmpty(hotkey) ? null : /* @__PURE__ */ React2.createElement("span", { className: styles.hotkey }, hotkey),
      /* @__PURE__ */ React2.createElement("span", { className: styles.content, style }, children)
    );
  }
);
ActionButton.displayName = "ActionButton";
var ActionButton_default = ActionButton;

// components/DropdownMenuTrigger.tsx
import styles4 from "./DropdownMenuTrigger.module-4KAFNKHW.module.css";

// common/position.ts
function calculate(triggerElement, popoverElement, scrollX = window.scrollX, scrollY = window.scrollY) {
  let triggerRect;
  let popoverRect;
  if (triggerElement) {
    triggerRect = triggerElement.getBoundingClientRect();
  }
  if (popoverElement) {
    popoverRect = popoverElement.getBoundingClientRect();
  }
  const spaceAbove = triggerRect.top;
  const spaceBelow = window.innerHeight - triggerRect.bottom;
  const spaceLeft = triggerRect.left;
  const spaceRight = window.innerWidth - triggerRect.right;
  const viewportHeightThreshold = window.innerHeight * 0.4;
  const viewportWidthThreshold = window.innerWidth * 0.4;
  let placement = "bottom";
  let top = 0;
  let left = 0;
  if (!popoverRect) {
    return { placement, position: { top: 0, left: 0 } };
  }
  if (spaceAbove >= viewportHeightThreshold && spaceAbove >= popoverRect.height) {
    placement = "top";
    top = triggerRect.top + scrollY - popoverRect.height;
    left = triggerRect.left + scrollX + (triggerRect.width - popoverRect.width) / 2;
  } else if (spaceBelow >= viewportHeightThreshold && spaceBelow >= popoverRect.height) {
    placement = "bottom";
    top = triggerRect.bottom + scrollY;
    left = triggerRect.left + scrollX + (triggerRect.width - popoverRect.width) / 2;
  } else if (spaceRight >= viewportWidthThreshold && spaceRight >= popoverRect.width) {
    placement = "right";
    top = triggerRect.top + scrollY + (triggerRect.height - popoverRect.height) / 2;
    left = triggerRect.right + scrollX;
  } else if (spaceLeft >= viewportWidthThreshold && spaceLeft >= popoverRect.width) {
    placement = "left";
    top = triggerRect.top + scrollY + (triggerRect.height - popoverRect.height) / 2;
    left = triggerRect.left + scrollX - popoverRect.width;
  } else {
    placement = "bottom";
    top = triggerRect.bottom + scrollY;
    left = triggerRect.left + scrollX + (triggerRect.width - popoverRect.width) / 2;
  }
  if (left < 0) left = 0;
  else if (left + popoverRect.width > window.innerWidth)
    left = window.innerWidth - popoverRect.width;
  if (top < 0) top = 0;
  else if (top + popoverRect.height > window.innerHeight + scrollY)
    top = window.innerHeight + scrollY - popoverRect.height;
  return { placement, position: { top, left } };
}

// components/DropdownMenuTrigger.tsx
import * as React8 from "react";

// components/DropdownMenu.tsx
import styles3 from "./DropdownMenu.module-MKQYY7JN.module.css";
import * as React6 from "react";

// components/ActionListItem.tsx
import styles2 from "./ActionListItem.module-Y5PLDDNB.module.css";
import * as React3 from "react";
var ActionListItem = (props) => {
  const { href, target, onClick, children, icon, style } = props;
  if (href) {
    return /* @__PURE__ */ React3.createElement(
      "a",
      {
        className: styles2.item,
        href,
        target,
        style,
        tabIndex: 0
      },
      /* @__PURE__ */ React3.createElement("figure", { className: styles2.icon }, icon),
      /* @__PURE__ */ React3.createElement("span", { className: styles2.text }, children)
    );
  }
  return /* @__PURE__ */ React3.createElement(
    "div",
    {
      className: styles2.item,
      onClick,
      style,
      tabIndex: 0,
      role: "button"
    },
    /* @__PURE__ */ React3.createElement("figure", { className: styles2.icon }, icon),
    /* @__PURE__ */ React3.createElement("span", { className: styles2.text }, children)
  );
};
var ActionListItem_default = ActionListItem;

// components/ModalTrigger.tsx
import * as React5 from "react";

// components/page/ModalContext.tsx
import * as React4 from "react";
var ModalContext = React4.createContext(null);
var ModalProvider = ({
  children
}) => {
  const [modalStack, setModalStack] = React4.useState([]);
  const open = (component, props) => {
    const key = `modal-${Date.now()}-${Math.random()}`;
    const newModal = { key, component, props };
    setModalStack((prev) => [...prev, newModal]);
    return key;
  };
  const close = (key) => {
    setModalStack(
      (prev) => key ? prev.filter((modal) => modal.key !== key) : prev.slice(0, -1)
    );
  };
  return /* @__PURE__ */ React4.createElement(ModalContext.Provider, { value: { modalStack, open, close } }, children);
};
var useModals = () => {
  const context = React4.useContext(ModalContext);
  if (!context) {
    throw new Error(
      "useModals must be used within a ModalProvider and use client"
    );
  }
  return context;
};

// components/ModalTrigger.tsx
function ModalTrigger({ children, modal, modalProps = {} }) {
  const { open } = useModals();
  const onHandleOpenModal = () => {
    open(modal, modalProps);
  };
  return React5.cloneElement(children, {
    onClick: onHandleOpenModal
  });
}
var ModalTrigger_default = ModalTrigger;

// modules/hotkeys/bound-hotkeys-proxy-provider.tsx
import { createContext as createContext2, useContext as useContext2 } from "react";
var BoundHotkeysProxyProvider = createContext2(void 0);
var useBoundHotkeysProxy = () => {
  return useContext2(BoundHotkeysProxyProvider);
};
function BoundHotkeysProxyProviderProvider({
  addHotkey,
  removeHotkey,
  children
}) {
  return /* @__PURE__ */ React.createElement(BoundHotkeysProxyProvider.Provider, { value: { addHotkey, removeHotkey } }, children);
}

// modules/hotkeys/hotkeys-provider.tsx
import {
  createContext as createContext3,
  useCallback,
  useContext as useContext3,
  useState as useState2
} from "react";
var HotkeysContext = createContext3({
  hotkeys: [],
  enabledScopes: [],
  // This array has to be empty instead of containing '*' as default, to check if the provider is set or not
  toggleScope: () => {
  },
  enableScope: () => {
  },
  disableScope: () => {
  }
});
var useHotkeysContext = () => {
  return useContext3(HotkeysContext);
};
var HotkeysProvider = ({
  initiallyActiveScopes = ["*"],
  children
}) => {
  const [internalActiveScopes, setInternalActiveScopes] = useState2(
    initiallyActiveScopes?.length > 0 ? initiallyActiveScopes : ["*"]
  );
  const [boundHotkeys, setBoundHotkeys] = useState2([]);
  const enableScope = useCallback((scope) => {
    setInternalActiveScopes((prev) => {
      if (prev.includes("*")) {
        return [scope];
      }
      return Array.from(/* @__PURE__ */ new Set([...prev, scope]));
    });
  }, []);
  const disableScope = useCallback((scope) => {
    setInternalActiveScopes((prev) => {
      if (prev.filter((s) => s !== scope).length === 0) {
        return ["*"];
      }
      return prev.filter((s) => s !== scope);
    });
  }, []);
  const toggleScope = useCallback((scope) => {
    setInternalActiveScopes((prev) => {
      if (prev.includes(scope)) {
        if (prev.filter((s) => s !== scope).length === 0) {
          return ["*"];
        }
        return prev.filter((s) => s !== scope);
      }
      if (prev.includes("*")) {
        return [scope];
      }
      return Array.from(/* @__PURE__ */ new Set([...prev, scope]));
    });
  }, []);
  const addBoundHotkey = useCallback((hotkey) => {
    setBoundHotkeys((prev) => [...prev, hotkey]);
  }, []);
  const removeBoundHotkey = useCallback((hotkey) => {
    setBoundHotkeys(
      (prev) => prev.filter((h) => !deepEqual(h, hotkey))
    );
  }, []);
  return /* @__PURE__ */ React.createElement(
    HotkeysContext.Provider,
    {
      value: {
        enabledScopes: internalActiveScopes,
        hotkeys: boundHotkeys,
        enableScope,
        disableScope,
        toggleScope
      }
    },
    /* @__PURE__ */ React.createElement(
      BoundHotkeysProxyProviderProvider,
      {
        addHotkey: addBoundHotkey,
        removeHotkey: removeBoundHotkey
      },
      children
    )
  );
};

// modules/hotkeys/parse-hotkeys.ts
var reservedModifierKeywords = ["shift", "alt", "meta", "mod", "ctrl"];
var mappedKeys = {
  esc: "escape",
  return: "enter",
  ".": "period",
  ",": "comma",
  "-": "slash",
  " ": "space",
  "`": "backquote",
  "#": "backslash",
  "+": "bracketright",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function mapKey(key) {
  return (key && mappedKeys[key] || key || "").trim().toLowerCase().replace(/key|digit|numpad|arrow/, "");
}
function isHotkeyModifier(key) {
  return reservedModifierKeywords.includes(key);
}
function parseKeysHookInput(keys, splitKey = ",") {
  return keys.split(splitKey);
}
function parseHotkey(hotkey, combinationKey = "+", description) {
  const keys = hotkey.toLocaleLowerCase().split(combinationKey).map((k) => mapKey(k));
  const modifiers = {
    alt: keys.includes("alt"),
    ctrl: keys.includes("ctrl") || keys.includes("control"),
    shift: keys.includes("shift"),
    meta: keys.includes("meta"),
    mod: keys.includes("mod")
  };
  const singleCharKeys = keys.filter(
    (k) => !reservedModifierKeywords.includes(k)
  );
  return {
    ...modifiers,
    keys: singleCharKeys,
    description,
    hotkey
  };
}

// modules/hotkeys/is-hotkey-pressed.ts
(() => {
  if (typeof document !== "undefined") {
    document.addEventListener("keydown", (e) => {
      if (e.key === void 0) {
        return;
      }
      pushToCurrentlyPressedKeys([mapKey(e.key), mapKey(e.code)]);
    });
    document.addEventListener("keyup", (e) => {
      if (e.key === void 0) {
        return;
      }
      removeFromCurrentlyPressedKeys([mapKey(e.key), mapKey(e.code)]);
    });
  }
  if (typeof window !== "undefined") {
    window.addEventListener("blur", () => {
      currentlyPressedKeys.clear();
    });
  }
})();
var currentlyPressedKeys = /* @__PURE__ */ new Set();
function isReadonlyArray(value) {
  return Array.isArray(value);
}
function isHotkeyPressed(key, splitKey = ",") {
  const hotkeyArray = isReadonlyArray(key) ? key : key.split(splitKey);
  return hotkeyArray.every(
    (hotkey) => currentlyPressedKeys.has(hotkey.trim().toLowerCase())
  );
}
function pushToCurrentlyPressedKeys(key) {
  const hotkeyArray = Array.isArray(key) ? key : [key];
  if (currentlyPressedKeys.has("meta")) {
    currentlyPressedKeys.forEach(
      (key2) => !isHotkeyModifier(key2) && currentlyPressedKeys.delete(key2.toLowerCase())
    );
  }
  hotkeyArray.forEach(
    (hotkey) => currentlyPressedKeys.add(hotkey.toLowerCase())
  );
}
function removeFromCurrentlyPressedKeys(key) {
  const hotkeyArray = Array.isArray(key) ? key : [key];
  if (key === "meta") {
    currentlyPressedKeys.clear();
  } else {
    hotkeyArray.forEach(
      (hotkey) => currentlyPressedKeys.delete(hotkey.toLowerCase())
    );
  }
}

// modules/hotkeys/use-deep-equal-memo.ts
import { useRef } from "react";
function useDeepEqualMemo(value) {
  const ref = useRef(void 0);
  if (!deepEqual(ref.current, value)) {
    ref.current = value;
  }
  return ref.current;
}

// modules/hotkeys/validators.ts
function maybePreventDefault(e, hotkey, preventDefault) {
  if (typeof preventDefault === "function" && preventDefault(e, hotkey) || preventDefault === true) {
    e.preventDefault();
  }
}
function isHotkeyEnabled(e, hotkey, enabled) {
  if (typeof enabled === "function") {
    return enabled(e, hotkey);
  }
  return enabled === true || enabled === void 0;
}
function isKeyboardEventTriggeredByInput(ev) {
  return isHotkeyEnabledOnTag(ev, ["input", "textarea", "select"]);
}
function isHotkeyEnabledOnTag(event, enabledOnTags = false) {
  const { target, composed } = event;
  let targetTagName = null;
  if (isCustomElement(target) && composed) {
    targetTagName = event.composedPath()[0] && event.composedPath()[0].tagName;
  } else {
    targetTagName = target && target.tagName;
  }
  if (isReadonlyArray(enabledOnTags)) {
    return Boolean(
      targetTagName && enabledOnTags && enabledOnTags.some(
        (tag) => tag.toLowerCase() === targetTagName?.toLowerCase()
      )
    );
  }
  return Boolean(targetTagName && enabledOnTags && enabledOnTags);
}
function isCustomElement(element) {
  return !!element.tagName && !element.tagName.startsWith("-") && element.tagName.includes("-");
}
function isScopeActive(activeScopes, scopes) {
  if (activeScopes.length === 0 && scopes) {
    console.warn(
      'A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>'
    );
    return true;
  }
  if (!scopes) {
    return true;
  }
  return activeScopes.some((scope) => scopes.includes(scope)) || activeScopes.includes("*");
}
var isHotkeyMatchingKeyboardEvent = (e, hotkey, ignoreModifiers = false) => {
  const { alt, meta, mod, shift, ctrl, keys } = hotkey;
  const {
    key: pressedKeyUppercase,
    code,
    ctrlKey,
    metaKey,
    shiftKey,
    altKey
  } = e;
  const keyCode = mapKey(code);
  const pressedKey = pressedKeyUppercase.toLowerCase();
  if (!keys?.includes(keyCode) && !keys?.includes(pressedKey) && !["ctrl", "control", "unknown", "meta", "alt", "shift", "os"].includes(
    keyCode
  )) {
    return false;
  }
  if (!ignoreModifiers) {
    if (alt === !altKey && pressedKey !== "alt") {
      return false;
    }
    if (shift === !shiftKey && pressedKey !== "shift") {
      return false;
    }
    if (mod) {
      if (!metaKey && !ctrlKey) {
        return false;
      }
    } else {
      if (meta === !metaKey && pressedKey !== "meta" && pressedKey !== "os") {
        return false;
      }
      if (ctrl === !ctrlKey && pressedKey !== "ctrl" && pressedKey !== "control") {
        return false;
      }
    }
  }
  if (keys && keys.length === 1 && (keys.includes(pressedKey) || keys.includes(keyCode))) {
    return true;
  }
  if (keys) {
    return isHotkeyPressed(keys);
  }
  if (!keys) {
    return true;
  }
  return false;
};

// modules/hotkeys/use-hotkeys.ts
import {
  useCallback as useCallback2,
  useEffect,
  useLayoutEffect,
  useRef as useRef2,
  useState as useState3
} from "react";
var stopPropagation = (e) => {
  e.stopPropagation();
  e.preventDefault();
  e.stopImmediatePropagation();
};
var useSafeLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function useHotkeys(keys, callback, options, dependencies) {
  const [ref, setRef] = useState3(null);
  const hasTriggeredRef = useRef2(false);
  const _options = !Array.isArray(options) ? options : !Array.isArray(dependencies) ? dependencies : void 0;
  const _keys = isReadonlyArray(keys) ? keys.join(_options?.splitKey) : keys;
  const _deps = Array.isArray(options) ? options : Array.isArray(dependencies) ? dependencies : void 0;
  const memoisedCB = useCallback2(callback, _deps ?? []);
  const cbRef = useRef2(memoisedCB);
  if (_deps) {
    cbRef.current = memoisedCB;
  } else {
    cbRef.current = callback;
  }
  const memoisedOptions = useDeepEqualMemo(_options);
  const { enabledScopes } = useHotkeysContext();
  const proxy = useBoundHotkeysProxy();
  useSafeLayoutEffect(() => {
    if (memoisedOptions?.enabled === false || !isScopeActive(enabledScopes, memoisedOptions?.scopes)) {
      return;
    }
    const listener = (e, isKeyUp = false) => {
      if (isKeyboardEventTriggeredByInput(e) && !isHotkeyEnabledOnTag(e, memoisedOptions?.enableOnFormTags)) {
        return;
      }
      if (ref !== null) {
        const rootNode = ref.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement !== ref && !ref.contains(rootNode.activeElement)) {
          stopPropagation(e);
          return;
        }
      }
      if (e.target?.isContentEditable && !memoisedOptions?.enableOnContentEditable) {
        return;
      }
      parseKeysHookInput(_keys, memoisedOptions?.splitKey).forEach((key) => {
        const hotkey = parseHotkey(key, memoisedOptions?.combinationKey);
        if (isHotkeyMatchingKeyboardEvent(
          e,
          hotkey,
          memoisedOptions?.ignoreModifiers
        ) || hotkey.keys?.includes("*")) {
          if (memoisedOptions?.ignoreEventWhen?.(e)) {
            return;
          }
          if (isKeyUp && hasTriggeredRef.current) {
            return;
          }
          maybePreventDefault(e, hotkey, memoisedOptions?.preventDefault);
          if (!isHotkeyEnabled(e, hotkey, memoisedOptions?.enabled)) {
            stopPropagation(e);
            return;
          }
          cbRef.current(e, hotkey);
          if (!isKeyUp) {
            hasTriggeredRef.current = true;
          }
        }
      });
    };
    const handleKeyDown = (event) => {
      if (event.key === void 0) {
        return;
      }
      pushToCurrentlyPressedKeys(mapKey(event.code));
      if (memoisedOptions?.keydown === void 0 && memoisedOptions?.keyup !== true || memoisedOptions?.keydown) {
        listener(event);
      }
    };
    const handleKeyUp = (event) => {
      if (event.key === void 0) {
        return;
      }
      removeFromCurrentlyPressedKeys(mapKey(event.code));
      hasTriggeredRef.current = false;
      if (memoisedOptions?.keyup) {
        listener(event, true);
      }
    };
    const domNode = ref || _options?.document || document;
    domNode.addEventListener("keyup", handleKeyUp);
    domNode.addEventListener("keydown", handleKeyDown);
    if (proxy) {
      parseKeysHookInput(_keys, memoisedOptions?.splitKey).forEach(
        (key) => proxy.addHotkey(
          parseHotkey(
            key,
            memoisedOptions?.combinationKey,
            memoisedOptions?.description
          )
        )
      );
    }
    return () => {
      domNode.removeEventListener("keyup", handleKeyUp);
      domNode.removeEventListener("keydown", handleKeyDown);
      if (proxy) {
        parseKeysHookInput(_keys, memoisedOptions?.splitKey).forEach(
          (key) => proxy.removeHotkey(
            parseHotkey(
              key,
              memoisedOptions?.combinationKey,
              memoisedOptions?.description
            )
          )
        );
      }
    };
  }, [ref, _keys, memoisedOptions, enabledScopes]);
  return setRef;
}

// modules/hotkeys/use-global-navigation.ts
var useGlobalNavigationHotkeys = () => {
  const onHandleSubmit = (event) => {
    const target = event.target;
    if (isFocusableElement(target)) {
      event.preventDefault();
      target.click();
    }
  };
  const onHandleNextFocus = (event) => {
    const target = event.target;
    if (isFocusableElement(target)) {
      event.preventDefault();
      const nextFocusable = findNextFocusable(target, "next");
      if (nextFocusable) {
        nextFocusable.focus();
      }
    }
  };
  const onHandlePreviousFocus = (event) => {
    const target = event.target;
    if (isFocusableElement(target)) {
      event.preventDefault();
      const previousFocusable = findNextFocusable(
        target,
        "previous"
      );
      if (previousFocusable) {
        previousFocusable.focus();
      }
    }
  };
  useHotkeys("ArrowDown", onHandleNextFocus);
  useHotkeys("ArrowUp", onHandlePreviousFocus);
  useHotkeys("ArrowRight", onHandleNextFocus);
  useHotkeys("ArrowLeft", onHandlePreviousFocus);
  useHotkeys("Enter", onHandleSubmit);
  useHotkeys(" ", onHandleSubmit);
};

// modules/hotkeys/use-record-hotkeys.ts
import { useCallback as useCallback3, useState as useState4 } from "react";
function useRecordHotkeys() {
  const [keys, setKeys] = useState4(/* @__PURE__ */ new Set());
  const [isRecording, setIsRecording] = useState4(false);
  const handler = useCallback3((event) => {
    if (event.key === void 0) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    setKeys((prev) => {
      const newKeys = new Set(prev);
      newKeys.add(mapKey(event.code));
      return newKeys;
    });
  }, []);
  const stop = useCallback3(() => {
    if (typeof document !== "undefined") {
      document.removeEventListener("keydown", handler);
      setIsRecording(false);
    }
  }, [handler]);
  const start = useCallback3(() => {
    setKeys(/* @__PURE__ */ new Set());
    if (typeof document !== "undefined") {
      stop();
      document.addEventListener("keydown", handler);
      setIsRecording(true);
    }
  }, [handler, stop]);
  const resetKeys = useCallback3(() => {
    setKeys(/* @__PURE__ */ new Set());
  }, []);
  return [keys, { start, stop, resetKeys, isRecording }];
}

// components/DropdownMenu.tsx
var DropdownMenu = React6.forwardRef(
  (props, ref) => {
    const { onClose, items, style, ...rest } = props;
    const handleHotkey = () => {
      if (onClose) onClose();
    };
    useHotkeys("space", handleHotkey);
    return /* @__PURE__ */ React6.createElement("div", { ref, className: styles3.root, style, ...rest }, items?.map((each, index) => {
      if (each.modal) {
        return /* @__PURE__ */ React6.createElement(
          ModalTrigger_default,
          {
            key: `action-items-${index}`,
            modal: each.modal,
            modalProps: each.modalProps
          },
          /* @__PURE__ */ React6.createElement(ActionListItem_default, { children: each.children, icon: each.icon })
        );
      }
      return /* @__PURE__ */ React6.createElement(
        ActionListItem_default,
        {
          key: `action-items-${index}`,
          children: each.children,
          icon: each.icon,
          href: each.href,
          target: each.target,
          onClick: () => {
            if (each.onClick) {
              each.onClick();
            }
            if (onClose) {
              onClose();
            }
          }
        }
      );
    }), /* @__PURE__ */ React6.createElement("footer", { className: styles3.footer }, "Press space to", " ", /* @__PURE__ */ React6.createElement(
      ActionButton_default,
      {
        hotkey: "\u2423",
        onClick: () => {
          if (onClose) onClose();
        }
      },
      "Close"
    )));
  }
);
DropdownMenu.displayName = "DropdownMenu";
var DropdownMenu_default = DropdownMenu;

// components/detectors/OutsideElementEvent.tsx
import * as React7 from "react";
var OutsideElementEvent = ({
  className,
  children,
  onOutsideEvent,
  style
}) => {
  const ref = React7.useRef(null);
  const handleOutsideEvent = React7.useCallback(
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.hasAttribute("data-detector-ignore")) {
        return;
      }
      if (ref.current && !ref.current.contains(event.target)) {
        onOutsideEvent(event);
      }
    },
    [onOutsideEvent]
  );
  React7.useEffect(() => {
    document.addEventListener("mousedown", handleOutsideEvent);
    document.addEventListener("touchstart", handleOutsideEvent);
    return () => {
      document.removeEventListener("mousedown", handleOutsideEvent);
      document.removeEventListener("touchstart", handleOutsideEvent);
    };
  }, [handleOutsideEvent]);
  return /* @__PURE__ */ React7.createElement("div", { ref, className, style }, children);
};
var OutsideElementEvent_default = OutsideElementEvent;

// components/DropdownMenuTrigger.tsx
import { createPortal } from "react-dom";
function DropdownMenuTrigger({
  children,
  items,
  hotkey
}) {
  const [open, setOpen] = React8.useState(false);
  const [focusChildren, setFocusChildren] = React8.useState(false);
  const [willClose, setWillClose] = React8.useState(false);
  const [placement, setPlacement] = React8.useState("bottom");
  const [position, setPosition] = React8.useState(
    { top: 0, left: 0 }
  );
  const triggerRef = React8.useRef(null);
  const elementRef = React8.useRef(null);
  const onClick = React8.useCallback((event) => {
    event.preventDefault();
    setOpen(true);
  }, []);
  const onOutsideEvent = React8.useCallback(() => setOpen(false), []);
  const onClose = React8.useCallback(() => setWillClose(true), []);
  if (hotkey) {
    useHotkeys(hotkey, () => {
      setOpen(!open);
    });
  }
  React8.useEffect(() => {
    if (focusChildren) {
      const element2 = elementRef.current;
      if (element2) {
        const firstFocusable = findFocusableDescendant(element2);
        if (firstFocusable) {
          firstFocusable.focus();
        } else {
          element2.focus();
        }
      }
      setFocusChildren(false);
    }
  }, [focusChildren]);
  React8.useEffect(() => {
    if (willClose) {
      setOpen(false);
      setWillClose(false);
    }
  }, [willClose]);
  React8.useEffect(() => {
    if (!open || !triggerRef.current || !elementRef.current) return;
    const updatePosition = () => {
      const { placement: placement2, position: position2 } = calculate(
        triggerRef.current,
        elementRef.current
      );
      setPlacement(placement2);
      setPosition(position2);
    };
    updatePosition();
    setFocusChildren(true);
    const handleResizeOrScroll = () => updatePosition();
    const observer = new MutationObserver(() => updatePosition());
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });
    window.addEventListener("resize", handleResizeOrScroll);
    window.addEventListener("scroll", handleResizeOrScroll, true);
    return () => {
      window.removeEventListener("resize", handleResizeOrScroll);
      window.removeEventListener("scroll", handleResizeOrScroll, true);
      observer.disconnect();
    };
  }, [open]);
  const element = open ? createPortal(
    /* @__PURE__ */ React8.createElement(OutsideElementEvent_default, { onOutsideEvent }, /* @__PURE__ */ React8.createElement(
      DropdownMenu_default,
      {
        onClose,
        ref: elementRef,
        items,
        style: {
          position: "absolute",
          top: `${position.top}px`,
          left: `${position.left}px`,
          zIndex: "var(--z-index-page-dropdown-menus)"
        },
        role: "dialog",
        "aria-modal": "true"
      }
    )),
    document.body
  ) : null;
  return /* @__PURE__ */ React8.createElement("div", { className: styles4.root }, React8.cloneElement(children, {
    tabIndex: 0,
    onClick,
    // @ts-ignore
    ref: triggerRef
  }), element);
}
var DropdownMenuTrigger_default = DropdownMenuTrigger;

// components/ButtonGroup.tsx
var ButtonGroup = (props) => {
  if (!props.items) {
    return null;
  }
  return /* @__PURE__ */ React9.createElement(
    "div",
    {
      className: cn(styles5.root, props.isFull ? styles5.full : null)
    },
    props.items.map((each) => {
      if (each.items) {
        return /* @__PURE__ */ React9.createElement(
          DropdownMenuTrigger_default,
          {
            key: each.body,
            items: each.items,
            hotkey: each.openHotkey
          },
          /* @__PURE__ */ React9.createElement(ActionButton_default, { hotkey: each.hotkey }, each.body)
        );
      }
      return /* @__PURE__ */ React9.createElement(
        ActionButton_default,
        {
          key: each.body,
          onClick: each.onClick,
          hotkey: each.hotkey
        },
        each.body
      );
    })
  );
};
var ButtonGroup_default = ButtonGroup;

// components/ActionBar.tsx
var ActionBar = ({ items }) => {
  return /* @__PURE__ */ React10.createElement("div", { className: styles6.root }, /* @__PURE__ */ React10.createElement(ButtonGroup_default, { items }));
};
var ActionBar_default = ActionBar;

// components/Accordion.tsx
import styles8 from "./Accordion.module-5FWSR5JI.module.css";
import * as React12 from "react";

// components/Row.tsx
import styles7 from "./Row.module-HEVEKF4J.module.css";
import * as React11 from "react";
var Row = React11.forwardRef(
  ({ children, ...rest }, ref) => {
    return /* @__PURE__ */ React11.createElement("section", { className: styles7.row, ref, ...rest }, children);
  }
);
Row.displayName = "Row";
var Row_default = Row;

// components/Accordion.tsx
var Accordion = ({
  defaultValue = false,
  title,
  children
}) => {
  const [show, setShow] = React12.useState(defaultValue);
  const accordionRef = React12.useRef(null);
  const toggleShow = () => {
    setShow((prevShow) => !prevShow);
  };
  return /* @__PURE__ */ React12.createElement(React12.Fragment, null, /* @__PURE__ */ React12.createElement(
    Row_default,
    {
      ref: accordionRef,
      tabIndex: 0,
      role: "button",
      onClick: toggleShow,
      "aria-expanded": show
    },
    /* @__PURE__ */ React12.createElement(
      "div",
      {
        className: cn(
          styles8.flex,
          show ? styles8.active : void 0
        )
      },
      /* @__PURE__ */ React12.createElement("span", { className: styles8.icon }, show ? "\u25BE" : "\u25B8"),
      /* @__PURE__ */ React12.createElement("span", { className: styles8.content }, title)
    )
  ), show && /* @__PURE__ */ React12.createElement(Row_default, { style: { paddingLeft: "1ch" } }, children));
};
var Accordion_default = Accordion;

// components/AlertBanner.tsx
import styles9 from "./AlertBanner.module-BIDEYUGR.module.css";
import * as React13 from "react";
var AlertBanner = ({
  style: propStyle,
  ...rest
}) => {
  const style = { ...propStyle };
  return /* @__PURE__ */ React13.createElement("div", { className: styles9.root, ...rest, style });
};
var AlertBanner_default = AlertBanner;

// components/Avatar.tsx
import styles10 from "./Avatar.module-NLDT6WNC.module.css";
import * as React14 from "react";
var Avatar = (props) => {
  const { src, style: propStyle, href, target, children, ...rest } = props;
  const backgroundStyle = src ? { backgroundImage: `url(${src})` } : {};
  const combinedStyle = { ...propStyle, ...backgroundStyle };
  let avatarElement;
  if (href) {
    avatarElement = /* @__PURE__ */ React14.createElement(
      "a",
      {
        className: cn(src ? styles10.root : styles10.placeholder),
        style: combinedStyle,
        href,
        target,
        tabIndex: 0
      }
    );
  } else {
    avatarElement = /* @__PURE__ */ React14.createElement(
      "figure",
      {
        className: cn(src ? styles10.root : styles10.placeholder),
        style: combinedStyle
      }
    );
  }
  if (!children) {
    return avatarElement;
  }
  return /* @__PURE__ */ React14.createElement("div", { className: styles10.parent, ...rest }, avatarElement, /* @__PURE__ */ React14.createElement("span", { className: styles10.right }, children));
};
var Avatar_default = Avatar;

// components/Badge.tsx
import styles11 from "./Badge.module-BQGQBA3Y.module.css";
import * as React15 from "react";
var Badge = ({ children, ...rest }) => {
  return /* @__PURE__ */ React15.createElement("span", { className: styles11.root, ...rest }, children);
};
var Badge_default = Badge;

// components/BarLoader.tsx
import * as React16 from "react";
import styles12 from "./BarLoader.module-BM6DDFME.module.css";
var BarLoader = ({ intervalRate, progress }) => {
  const [currentProgress, setCurrentProgress] = React16.useState(
    progress || 0
  );
  React16.useEffect(() => {
    if (progress !== void 0) {
      setCurrentProgress(progress);
      return;
    }
    if (!intervalRate) return;
    const interval = setInterval(() => {
      setCurrentProgress((prev) => (prev + 10) % 110);
    }, intervalRate);
    return () => clearInterval(interval);
  }, [intervalRate, progress]);
  return /* @__PURE__ */ React16.createElement("div", { className: styles12.root }, /* @__PURE__ */ React16.createElement(
    "div",
    {
      className: styles12.bar,
      style: {
        width: `${Math.min(currentProgress, 100)}%`
      }
    }
  ));
};
var BarLoader_default = BarLoader;

// components/BarProgress.tsx
import styles13 from "./BarProgress.module-24D6NC6W.module.css";
import * as React17 from "react";
var BarProgress = ({
  intervalRate,
  progress,
  fillChar = "\u2591"
}) => {
  const [currentProgress, setCurrentProgress] = React17.useState(progress ?? 0);
  const [containerWidth, setContainerWidth] = React17.useState(0);
  const [charWidth, setCharWidth] = React17.useState(0);
  const containerRef = React17.useRef(null);
  const measureRef = React17.useRef(null);
  React17.useEffect(() => {
    if (typeof progress === "number") {
      setCurrentProgress(progress);
      return;
    }
    if (!intervalRate) return;
    const interval = setInterval(() => {
      setCurrentProgress((prev) => (prev + 10) % 110);
    }, intervalRate);
    return () => clearInterval(interval);
  }, [intervalRate, progress]);
  React17.useLayoutEffect(() => {
    if (!measureRef.current) return;
    const rect = measureRef.current.getBoundingClientRect();
    if (rect.width > 0) {
      setCharWidth(rect.width);
    } else {
      requestAnimationFrame(() => {
        const retryRect = measureRef.current?.getBoundingClientRect();
        if (retryRect && retryRect.width > 0) {
          setCharWidth(retryRect.width);
        }
      });
    }
  }, [fillChar]);
  React17.useEffect(() => {
    if (!containerRef.current) return;
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width } = entry.contentRect;
        setContainerWidth(width);
      }
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);
  const cappedProgress = Math.min(currentProgress, 100);
  let maxChars = 10;
  if (charWidth > 0 && containerWidth > 0) {
    maxChars = Math.max(1, Math.floor(containerWidth / charWidth));
  }
  const filledChars = Math.round(cappedProgress / 100 * maxChars);
  const barStr = fillChar.repeat(filledChars);
  return /* @__PURE__ */ React17.createElement(
    "div",
    {
      className: styles13.root,
      ref: containerRef,
      "aria-valuenow": cappedProgress,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      role: "progressbar"
    },
    /* @__PURE__ */ React17.createElement("span", { ref: measureRef, className: styles13.measure }, fillChar),
    barStr
  );
};
var BarProgress_default = BarProgress;

// components/Block.tsx
import styles14 from "./Block.module-2V3NS2VW.module.css";
import * as React18 from "react";
var Block = ({ children, ...rest }) => {
  return /* @__PURE__ */ React18.createElement("span", { className: styles14.block, ...rest }, children);
};
var Block_default = Block;

// components/BlockLoader.tsx
import styles15 from "./BlockLoader.module-Y5KSMGWS.module.css";
import * as React19 from "react";
var SEQUENCES = [
  ["\u2801", "\u2802", "\u2804", "\u2840", "\u2880", "\u2820", "\u2810", "\u2808"],
  ["\u28FE", "\u28FD", "\u28FB", "\u28BF", "\u287F", "\u28DF", "\u28EF", "\u28F7"],
  ["\u2596", "\u2598", "\u259D", "\u2597"],
  ["\u2581", "\u2582", "\u2583", "\u2584", "\u2585", "\u2586", "\u2587", "\u2588", "\u2587", "\u2586", "\u2585", "\u2584", "\u2583", "\u2581"],
  ["\u2589", "\u258A", "\u258B", "\u258C", "\u258D", "\u258E", "\u258F", "\u258E", "\u258D", "\u258C", "\u258B", "\u258A", "\u2589"],
  ["\u2190", "\u2196", "\u2191", "\u2197", "\u2192", "\u2198", "\u2193", "\u2199"],
  ["\u2524", "\u2518", "\u2534", "\u2514", "\u251C", "\u250C", "\u252C", "\u2510"],
  ["\u25E2", "\u25E3", "\u25E4", "\u25E5"],
  ["\u25F0", "\u25F3", "\u25F2", "\u25F1"],
  ["\u25F4", "\u25F7", "\u25F6", "\u25F5"],
  ["\u25D0", "\u25D3", "\u25D1", "\u25D2"]
];
var BlockLoader = ({ mode = 0 }) => {
  if (!SEQUENCES[mode]) {
    return /* @__PURE__ */ React19.createElement("span", { className: styles15.block }, "\uFFFD");
  }
  const [index, setIndex] = React19.useState(0);
  const intervalRef = React19.useRef(null);
  const indexLength = SEQUENCES[mode].length;
  React19.useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = window.setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % indexLength);
    }, 100);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [indexLength]);
  return /* @__PURE__ */ React19.createElement("span", { className: styles15.root }, SEQUENCES[mode][index]);
};
var BlockLoader_default = BlockLoader;

// components/BreadCrumbs.tsx
import styles16 from "./BreadCrumbs.module-4ML3WO5H.module.css";
import * as React20 from "react";
var BreadCrumbs = ({ items }) => {
  return /* @__PURE__ */ React20.createElement("nav", { "aria-label": "breadcrumb", className: styles16.root }, items.map((item, index) => {
    const linkElement = /* @__PURE__ */ React20.createElement(
      "a",
      {
        className: styles16.link,
        href: item.url,
        target: "_blank",
        tabIndex: 0,
        rel: "noreferrer"
      },
      item.name
    );
    return /* @__PURE__ */ React20.createElement("span", { className: styles16.line, key: index }, index === items.length - 1 ? /* @__PURE__ */ React20.createElement("span", null, linkElement) : linkElement, index < items.length - 1 && /* @__PURE__ */ React20.createElement("span", { className: styles16.symbol }, " \u276F "));
  }));
};
var BreadCrumbs_default = BreadCrumbs;

// components/Button.tsx
import styles17 from "./Button.module-XCDSC32A.module.css";
import * as React21 from "react";
var Button = ({
  theme = "PRIMARY",
  isDisabled,
  children,
  className,
  ...rest
}) => {
  let classNames2 = cn(styles17.root, styles17.primary, className);
  if (theme === "SECONDARY") {
    classNames2 = cn(styles17.root, styles17.secondary);
  }
  if (isDisabled) {
    classNames2 = cn(styles17.root, styles17.disabled);
    return /* @__PURE__ */ React21.createElement("div", { className: classNames2 }, children);
  }
  return /* @__PURE__ */ React21.createElement("button", { className: classNames2, tabIndex: 0, disabled: isDisabled, ...rest }, children);
};
var Button_default = Button;

// components/CanvasPlatformer.tsx
import styles18 from "./CanvasPlatformer.module-B62NHV5M.module.css";
import * as React22 from "react";
var LINE_HEIGHT = 20;
var CHARACTER_WIDTH = 9.6;
var GRAVITY = 0.3;
var MOVE_SPEED = 2;
var JUMP_SPEED = -6;
var FRICTION = 0.85;
var CanvasPlatformer = ({ rows = 25 }) => {
  const canvasRef = React22.useRef(null);
  const [focused, setFocused] = React22.useState(false);
  const positionRef = React22.useRef({ x: 50, y: 0 });
  const velocityRef = React22.useRef({ x: 0, y: 0 });
  const keysRef = React22.useRef({
    left: false,
    right: false,
    jump: false
  });
  const platformBlocksRef = React22.useRef([]);
  React22.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const parent = canvas.parentElement;
    if (!parent) return;
    const resizeCanvas = () => {
      const parentWidth = parent.clientWidth;
      const canvasHeight = rows * LINE_HEIGHT;
      canvas.width = parentWidth;
      canvas.height = canvasHeight;
      const platformY = canvas.height - LINE_HEIGHT * 2;
      positionRef.current.y = platformY - LINE_HEIGHT;
      platformBlocksRef.current = [];
      const numBlocks = Math.floor(parentWidth / CHARACTER_WIDTH);
      for (let i = 0; i < numBlocks; i++) {
        platformBlocksRef.current.push({
          x: i * CHARACTER_WIDTH,
          y: platformY
        });
      }
    };
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);
    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  }, [rows]);
  React22.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const handleFocus = () => setFocused(true);
    const handleBlur = () => {
      setFocused(false);
      keysRef.current = { left: false, right: false, jump: false };
    };
    canvas.tabIndex = 0;
    canvas.addEventListener("focus", handleFocus);
    canvas.addEventListener("blur", handleBlur);
    const handleClick = (e) => {
      const rect = canvas.getBoundingClientRect();
      const x = Math.floor((e.clientX - rect.left) / CHARACTER_WIDTH) * CHARACTER_WIDTH;
      const y = Math.floor((e.clientY - rect.top) / LINE_HEIGHT) * LINE_HEIGHT;
      const blocks = platformBlocksRef.current;
      const existingIndex = blocks.findIndex((b) => b.x === x && b.y === y);
      if (existingIndex !== -1) {
        blocks.splice(existingIndex, 1);
      } else {
        blocks.push({ x, y });
      }
    };
    canvas.addEventListener("click", handleClick);
    return () => {
      canvas.removeEventListener("focus", handleFocus);
      canvas.removeEventListener("blur", handleBlur);
      canvas.removeEventListener("click", handleClick);
    };
  }, []);
  React22.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!focused) return;
      if (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.code === "Space") {
        e.preventDefault();
        e.stopPropagation();
      }
      if (e.key === "ArrowLeft") keysRef.current.left = true;
      if (e.key === "ArrowRight") keysRef.current.right = true;
      if (e.code === "Space") keysRef.current.jump = true;
    };
    const handleKeyUp = (e) => {
      if (!focused) return;
      if (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.code === "Space") {
        e.preventDefault();
        e.stopPropagation();
      }
      if (e.key === "ArrowLeft") keysRef.current.left = false;
      if (e.key === "ArrowRight") keysRef.current.right = false;
      if (e.code === "Space") keysRef.current.jump = false;
    };
    window.addEventListener("keydown", handleKeyDown, { capture: true });
    window.addEventListener("keyup", handleKeyUp, { capture: true });
    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
      window.removeEventListener("keyup", handleKeyUp, { capture: true });
    };
  }, [focused]);
  React22.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const loop = () => {
      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      const pos = positionRef.current;
      const vel = velocityRef.current;
      const keys = keysRef.current;
      const blocks = platformBlocksRef.current;
      const themeBorderColor = getComputedStyle(document.body).getPropertyValue("--theme-border").trim();
      const themeTextColor = getComputedStyle(document.body).getPropertyValue("--theme-text").trim();
      ctx.fillStyle = themeBorderColor;
      for (const b of blocks) {
        ctx.fillRect(b.x, b.y, CHARACTER_WIDTH, LINE_HEIGHT);
      }
      if (keys.left) vel.x = -MOVE_SPEED;
      else if (keys.right) vel.x = MOVE_SPEED;
      else {
        vel.x *= FRICTION;
        if (Math.abs(vel.x) < 0.1) vel.x = 0;
      }
      const oldY = pos.y;
      vel.y += GRAVITY;
      pos.x += vel.x;
      pos.y += vel.y;
      if (pos.x < 0) pos.x = 0;
      if (pos.x > w - CHARACTER_WIDTH) pos.x = w - CHARACTER_WIDTH;
      let groundY = h;
      for (const b of blocks) {
        const horizontallyOverlapping = pos.x + CHARACTER_WIDTH > b.x && pos.x < b.x + CHARACTER_WIDTH;
        if (horizontallyOverlapping && oldY + LINE_HEIGHT <= b.y && pos.y + LINE_HEIGHT >= b.y) {
          if (b.y < groundY) groundY = b.y;
        }
      }
      if (pos.y + LINE_HEIGHT > groundY) {
        pos.y = groundY - LINE_HEIGHT;
        vel.y = 0;
        if (keys.jump) vel.y = JUMP_SPEED;
      }
      ctx.fillStyle = themeTextColor;
      ctx.fillRect(pos.x, pos.y, CHARACTER_WIDTH, LINE_HEIGHT);
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }, []);
  const handleJumpClick = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const pos = positionRef.current;
    const vel = velocityRef.current;
    const w = canvas.width;
    const h = canvas.height;
    let groundY = h;
    for (const b of platformBlocksRef.current) {
      const horizontallyOverlapping = pos.x + CHARACTER_WIDTH > b.x && pos.x < b.x + CHARACTER_WIDTH;
      if (horizontallyOverlapping && pos.y + LINE_HEIGHT <= b.y) {
        if (b.y < groundY) groundY = b.y;
      }
    }
    if (pos.y + LINE_HEIGHT >= groundY) vel.y = JUMP_SPEED;
  };
  const handleLeftClick = () => {
    const pos = positionRef.current;
    pos.x -= CHARACTER_WIDTH;
    if (pos.x < 0) pos.x = 0;
  };
  const handleRightClick = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const pos = positionRef.current;
    pos.x += CHARACTER_WIDTH;
    if (pos.x > canvas.width - CHARACTER_WIDTH)
      pos.x = canvas.width - CHARACTER_WIDTH;
  };
  return /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(ActionButton_default, { hotkey: "\u2423", onClick: handleJumpClick }, "Jump"), /* @__PURE__ */ React22.createElement(ActionButton_default, { hotkey: "\u2190", onClick: handleLeftClick }, "Left"), /* @__PURE__ */ React22.createElement(ActionButton_default, { hotkey: "\u2192", onClick: handleRightClick }, "Right"), /* @__PURE__ */ React22.createElement("div", { className: styles18.container }, /* @__PURE__ */ React22.createElement("canvas", { className: styles18.root, ref: canvasRef })));
};
var CanvasPlatformer_default = CanvasPlatformer;

// components/CanvasSnake.tsx
import styles19 from "./CanvasSnake.module-B62NHV5M.module.css";
import * as React23 from "react";
var LINE_HEIGHT2 = 20;
var CHARACTER_WIDTH2 = 9.6;
var CanvasSnake = ({ rows = 25 }) => {
  const canvasRef = React23.useRef(null);
  const [focused, setFocused] = React23.useState(false);
  const directionRef = React23.useRef("RIGHT");
  const snakeRef = React23.useRef([]);
  const fruitRef = React23.useRef({ x: 0, y: 0 });
  const gridWidthRef = React23.useRef(0);
  const gridHeightRef = React23.useRef(0);
  const lastMoveTimeRef = React23.useRef(0);
  const moveInterval = 150;
  const animationFrameRef = React23.useRef(null);
  const reset = React23.useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const w = canvas.width;
    const h = canvas.height;
    const gridWidth = Math.floor(w / CHARACTER_WIDTH2);
    const gridHeight = Math.floor(h / LINE_HEIGHT2);
    gridWidthRef.current = gridWidth;
    gridHeightRef.current = gridHeight;
    const startX = Math.floor(gridWidth / 2);
    const startY = Math.floor(gridHeight / 2);
    snakeRef.current = [
      { x: startX - 13, y: startY },
      { x: startX - 12, y: startY },
      { x: startX - 11, y: startY },
      { x: startX - 10, y: startY },
      { x: startX - 9, y: startY },
      { x: startX - 8, y: startY },
      { x: startX - 7, y: startY },
      { x: startX - 6, y: startY },
      { x: startX - 5, y: startY },
      { x: startX - 4, y: startY },
      { x: startX - 3, y: startY },
      { x: startX - 2, y: startY },
      { x: startX - 1, y: startY },
      { x: startX, y: startY }
    ];
    directionRef.current = "RIGHT";
    fruitRef.current = {
      x: Math.floor(Math.random() * gridWidth),
      y: Math.floor(Math.random() * gridHeight)
    };
    lastMoveTimeRef.current = performance.now();
  }, []);
  React23.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const parent = canvas.parentElement;
    if (!parent) return;
    const onHandleResizeCanvas = () => {
      const parentWidth = parent.clientWidth;
      const canvasHeight = rows * LINE_HEIGHT2;
      canvas.width = parentWidth;
      canvas.height = canvasHeight;
      reset();
    };
    onHandleResizeCanvas();
    window.addEventListener("resize", onHandleResizeCanvas);
    return () => {
      window.removeEventListener("resize", onHandleResizeCanvas);
    };
  }, [rows, reset]);
  React23.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const onHandleFocus = () => {
      setFocused(true);
    };
    const onHandleBlur = () => {
      setFocused(false);
    };
    canvas.tabIndex = 0;
    canvas.addEventListener("focus", onHandleFocus);
    canvas.addEventListener("blur", onHandleBlur);
    return () => {
      canvas.removeEventListener("focus", onHandleFocus);
      canvas.removeEventListener("blur", onHandleBlur);
    };
  }, []);
  React23.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!focused) return;
      if (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "ArrowUp" || e.key === "ArrowDown") {
        e.preventDefault();
        e.stopPropagation();
      }
      const currentDir = directionRef.current;
      if (e.key === "ArrowLeft" && currentDir !== "RIGHT")
        directionRef.current = "LEFT";
      if (e.key === "ArrowRight" && currentDir !== "LEFT")
        directionRef.current = "RIGHT";
      if (e.key === "ArrowUp" && currentDir !== "DOWN")
        directionRef.current = "UP";
      if (e.key === "ArrowDown" && currentDir !== "UP")
        directionRef.current = "DOWN";
    };
    window.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [focused]);
  React23.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const themeBorderColor = getComputedStyle(document.body).getPropertyValue("--theme-text").trim();
    const themeTextColor = getComputedStyle(document.body).getPropertyValue("--theme-focused-foreground").trim();
    const moveSnake = () => {
      const snake = snakeRef.current;
      const dir = directionRef.current;
      const head = snake[snake.length - 1];
      const newHead = { x: head.x, y: head.y };
      if (dir === "LEFT") newHead.x -= 1;
      if (dir === "RIGHT") newHead.x += 1;
      if (dir === "UP") newHead.y -= 1;
      if (dir === "DOWN") newHead.y += 1;
      if (newHead.x < 0 || newHead.x >= gridWidthRef.current || newHead.y < 0 || newHead.y >= gridHeightRef.current) {
        reset();
        return;
      }
      for (const seg of snake) {
        if (seg.x === newHead.x && seg.y === newHead.y) {
          reset();
          return;
        }
      }
      snake.push(newHead);
      if (newHead.x === fruitRef.current.x && newHead.y === fruitRef.current.y) {
        placeTarget();
      } else {
        snake.shift();
      }
    };
    const placeTarget = () => {
      const snake = snakeRef.current;
      const gridW = gridWidthRef.current;
      const gridH = gridHeightRef.current;
      let fruitPos;
      while (true) {
        fruitPos = {
          x: Math.floor(Math.random() * gridW),
          y: Math.floor(Math.random() * gridH)
        };
        if (!snake.some((s) => s.x === fruitPos.x && s.y === fruitPos.y)) break;
      }
      fruitRef.current = fruitPos;
    };
    const loop = (time) => {
      if (!ctx) return;
      if (!focused) return;
      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = themeTextColor;
      ctx.fillRect(
        fruitRef.current.x * CHARACTER_WIDTH2,
        fruitRef.current.y * LINE_HEIGHT2,
        CHARACTER_WIDTH2,
        LINE_HEIGHT2
      );
      ctx.fillStyle = themeBorderColor;
      for (const segment of snakeRef.current) {
        ctx.fillRect(
          segment.x * CHARACTER_WIDTH2,
          segment.y * LINE_HEIGHT2,
          CHARACTER_WIDTH2,
          LINE_HEIGHT2
        );
      }
      if (time - lastMoveTimeRef.current > moveInterval) {
        moveSnake();
        lastMoveTimeRef.current = time;
      }
      animationFrameRef.current = requestAnimationFrame(loop);
    };
    if (focused && animationFrameRef.current === null) {
      animationFrameRef.current = requestAnimationFrame(loop);
    }
    return () => {
      if (animationFrameRef.current !== null) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
    };
  }, [focused, reset]);
  React23.useEffect(() => {
    if (!focused) {
      if (animationFrameRef.current !== null) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
      return;
    }
    if (animationFrameRef.current === null && canvasRef.current) {
      animationFrameRef.current = requestAnimationFrame((time) => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        const themeBorderColor = getComputedStyle(document.body).getPropertyValue("--theme-border").trim();
        const themeTextColor = getComputedStyle(document.body).getPropertyValue("--theme-text").trim();
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = themeBorderColor;
        ctx.fillRect(
          fruitRef.current.x * CHARACTER_WIDTH2,
          fruitRef.current.y * LINE_HEIGHT2,
          CHARACTER_WIDTH2,
          LINE_HEIGHT2
        );
        ctx.fillStyle = themeTextColor;
        for (const segment of snakeRef.current) {
          ctx.fillRect(
            segment.x * CHARACTER_WIDTH2,
            segment.y * LINE_HEIGHT2,
            CHARACTER_WIDTH2,
            LINE_HEIGHT2
          );
        }
        lastMoveTimeRef.current = time;
        animationFrameRef.current = requestAnimationFrame(loop);
        function loop(time2) {
          if (!focused) return;
          if (!ctx) return;
          if (!canvas) return;
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.fillStyle = themeBorderColor;
          ctx.fillRect(
            fruitRef.current.x * CHARACTER_WIDTH2,
            fruitRef.current.y * LINE_HEIGHT2,
            CHARACTER_WIDTH2,
            LINE_HEIGHT2
          );
          ctx.fillStyle = themeTextColor;
          for (const segment of snakeRef.current) {
            ctx.fillRect(
              segment.x * CHARACTER_WIDTH2,
              segment.y * LINE_HEIGHT2,
              CHARACTER_WIDTH2,
              LINE_HEIGHT2
            );
          }
          if (time2 - lastMoveTimeRef.current > moveInterval) {
            moveSnake();
            lastMoveTimeRef.current = time2;
          }
          animationFrameRef.current = requestAnimationFrame(loop);
        }
        const moveSnake = () => {
          const snake = snakeRef.current;
          const dir = directionRef.current;
          const head = snake[snake.length - 1];
          const newHead = { x: head.x, y: head.y };
          if (dir === "LEFT") newHead.x -= 1;
          if (dir === "RIGHT") newHead.x += 1;
          if (dir === "UP") newHead.y -= 1;
          if (dir === "DOWN") newHead.y += 1;
          if (newHead.x < 0 || newHead.x >= gridWidthRef.current || newHead.y < 0 || newHead.y >= gridHeightRef.current) {
            reset();
            return;
          }
          for (const seg of snake) {
            if (seg.x === newHead.x && seg.y === newHead.y) {
              reset();
              return;
            }
          }
          snake.push(newHead);
          if (newHead.x === fruitRef.current.x && newHead.y === fruitRef.current.y) {
            placeTarget();
          } else {
            snake.shift();
          }
        };
        const placeTarget = () => {
          const snake = snakeRef.current;
          const gridW = gridWidthRef.current;
          const gridH = gridHeightRef.current;
          let fruitPos;
          while (true) {
            fruitPos = {
              x: Math.floor(Math.random() * gridW),
              y: Math.floor(Math.random() * gridH)
            };
            if (!snake.some((s) => s.x === fruitPos.x && s.y === fruitPos.y))
              break;
          }
          fruitRef.current = fruitPos;
        };
      });
    }
  }, [focused, reset]);
  const onHandleClickUp = () => {
    if (directionRef.current !== "DOWN") directionRef.current = "UP";
  };
  const onHandleClickDown = () => {
    if (directionRef.current !== "UP") directionRef.current = "DOWN";
  };
  const onHandleClickLeft = () => {
    if (directionRef.current !== "RIGHT") directionRef.current = "LEFT";
  };
  const onHandleClickRight = () => {
    if (directionRef.current !== "LEFT") directionRef.current = "RIGHT";
  };
  return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement(ActionButton_default, { hotkey: "\u2191", onClick: onHandleClickUp }, "Up"), /* @__PURE__ */ React23.createElement(ActionButton_default, { hotkey: "\u2193", onClick: onHandleClickDown }, "Down"), /* @__PURE__ */ React23.createElement(ActionButton_default, { hotkey: "\u2190", onClick: onHandleClickLeft }, "Left"), /* @__PURE__ */ React23.createElement(ActionButton_default, { hotkey: "\u2192", onClick: onHandleClickRight }, "Right"), /* @__PURE__ */ React23.createElement("div", { className: styles19.container }, /* @__PURE__ */ React23.createElement("canvas", { className: styles19.root, ref: canvasRef })));
};
var CanvasSnake_default = CanvasSnake;

// components/Card.tsx
import * as React24 from "react";
import styles20 from "./Card.module-GGGUWLLF.module.css";
var Card = ({ children, mode, title, className, loading }) => {
  let titleElement = /* @__PURE__ */ React24.createElement("header", { className: styles20.action }, /* @__PURE__ */ React24.createElement("div", { className: styles20.left, "aria-hidden": "true" }), title ? /* @__PURE__ */ React24.createElement("h2", { className: styles20.title }, title) : null, /* @__PURE__ */ React24.createElement("div", { className: styles20.right, "aria-hidden": "true" }));
  if (mode === "left") {
    titleElement = /* @__PURE__ */ React24.createElement("header", { className: styles20.action }, /* @__PURE__ */ React24.createElement("div", { className: styles20.leftCorner, "aria-hidden": "true" }), /* @__PURE__ */ React24.createElement("h2", { className: styles20.title }, title), /* @__PURE__ */ React24.createElement("div", { className: styles20.right, "aria-hidden": "true" }));
  }
  if (mode === "right") {
    titleElement = /* @__PURE__ */ React24.createElement("header", { className: styles20.action }, /* @__PURE__ */ React24.createElement("div", { className: styles20.left, "aria-hidden": "true" }), /* @__PURE__ */ React24.createElement("h2", { className: styles20.title }, title), /* @__PURE__ */ React24.createElement("div", { className: styles20.rightCorner, "aria-hidden": "true" }));
  }
  return /* @__PURE__ */ React24.createElement("div", { className: cn("relative overflow-y-auto h-full", className) }, /* @__PURE__ */ React24.createElement("div", { className: "absolute top-0 left-0 w-full h-full" }, /* @__PURE__ */ React24.createElement(
    "article",
    {
      className: cn(styles20.card, className, {
        [styles20.titled]: Boolean(title)
      })
    },
    title ? titleElement : null,
    /* @__PURE__ */ React24.createElement(
      "section",
      {
        className: cn(styles20.children, className, {
          [styles20.titled]: Boolean(title)
        })
      },
      loading ? /* @__PURE__ */ React24.createElement(BarLoader_default, { intervalRate: 100 }) : children
    )
  )));
};
var Card_default = Card;

// components/CardDouble.tsx
import styles21 from "./CardDouble.module-EHH7LSUN.module.css";
import * as React25 from "react";
var CardDouble = ({
  children,
  mode,
  title,
  style,
  ...rest
}) => {
  let titleElement = /* @__PURE__ */ React25.createElement("header", { className: styles21.action }, /* @__PURE__ */ React25.createElement("div", { className: styles21.left, "aria-hidden": "true" }), /* @__PURE__ */ React25.createElement("h2", { className: styles21.title }, title), /* @__PURE__ */ React25.createElement("div", { className: styles21.right, "aria-hidden": "true" }));
  if (mode === "left") {
    titleElement = /* @__PURE__ */ React25.createElement("header", { className: styles21.action }, /* @__PURE__ */ React25.createElement("div", { className: styles21.leftCorner, "aria-hidden": "true" }), /* @__PURE__ */ React25.createElement("h2", { className: styles21.title }, title), /* @__PURE__ */ React25.createElement("div", { className: styles21.right, "aria-hidden": "true" }));
  }
  if (mode === "right") {
    titleElement = /* @__PURE__ */ React25.createElement("header", { className: styles21.action }, /* @__PURE__ */ React25.createElement("div", { className: styles21.left, "aria-hidden": "true" }), /* @__PURE__ */ React25.createElement("h2", { className: styles21.title }, title), /* @__PURE__ */ React25.createElement("div", { className: styles21.rightCorner, "aria-hidden": "true" }));
  }
  return /* @__PURE__ */ React25.createElement("article", { className: styles21.card }, titleElement, /* @__PURE__ */ React25.createElement("section", { className: styles21.children }, /* @__PURE__ */ React25.createElement("section", { className: styles21.borderChildren, style }, children)));
};
var CardDouble_default = CardDouble;

// components/Checkbox.tsx
import styles22 from "./Checkbox.module-ZPG4BHXA.module.css";
import * as React26 from "react";
var Checkbox = ({
  style,
  name,
  checked,
  defaultChecked = false,
  onChange,
  children,
  disabled = false
}) => {
  const checkboxId = `${name}-checkbox`;
  const inputRef = React26.useRef(null);
  const [isChecked, setIsChecked] = React26.useState(defaultChecked);
  const [isFocused, setIsFocused] = React26.useState(false);
  const handleKeyDown = (event) => {
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        inputRef.current?.click();
        break;
      case "ArrowUp":
      case "ArrowLeft": {
        event.preventDefault();
        const previousFocusable = findNextFocusable(
          document.activeElement,
          "previous"
        );
        previousFocusable?.focus();
        break;
      }
      case "ArrowDown":
      case "ArrowRight": {
        event.preventDefault();
        const nextFocusable = findNextFocusable(
          document.activeElement,
          "next"
        );
        nextFocusable?.focus();
        break;
      }
      default:
        break;
    }
  };
  const handleChange = (event) => {
    const newCheckedStatus = event.target.checked;
    setIsChecked(newCheckedStatus);
    if (onChange) {
      onChange(event);
    }
  };
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);
  React26.useEffect(() => {
    if (checked !== void 0) {
      setIsChecked(checked);
    }
  }, [checked]);
  return /* @__PURE__ */ React26.createElement(
    "div",
    {
      className: cn(styles22.section, {
        [styles22.checked]: isChecked,
        [styles22.focused]: isFocused,
        [styles22.disabled]: disabled
      }),
      style
    },
    /* @__PURE__ */ React26.createElement("div", { className: styles22.relative }, /* @__PURE__ */ React26.createElement(
      "input",
      {
        className: styles22.input,
        id: checkboxId,
        type: "checkbox",
        name,
        defaultChecked,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        onBlur: handleBlur,
        tabIndex: 0,
        ref: inputRef,
        disabled
      }
    ), /* @__PURE__ */ React26.createElement("label", { className: styles22.figure, htmlFor: checkboxId }, isChecked ? "\u25A0" : "\xA0")),
    /* @__PURE__ */ React26.createElement("div", { className: styles22.right }, "\xA0\xA0", children)
  );
};
var Checkbox_default = Checkbox;

// components/Chessboard.tsx
import styles23 from "./Chessboard.module-WMKSBX5K.module.css";
import * as React27 from "react";
var FILE = ["A", "B", "C", "D", "E", "F", "G", "H"];
var RANK = [8, 7, 6, 5, 4, 3, 2, 1];
var getPieceSymbol = (piece) => {
  const mapping = {
    K: "\u2654",
    Q: "\u2655",
    R: "\u2656",
    B: "\u2657",
    N: "\u2658",
    P: "\u2659",
    k: "\u265A",
    q: "\u265B",
    r: "\u265C",
    b: "\u265D",
    n: "\u265E",
    p: "\u265F"
  };
  return mapping[piece] || "";
};
var Chessboard = ({ board }) => {
  return /* @__PURE__ */ React27.createElement("table", { className: styles23.board }, /* @__PURE__ */ React27.createElement("tbody", null, /* @__PURE__ */ React27.createElement("tr", null, /* @__PURE__ */ React27.createElement("td", { className: styles23.corner }), FILE.map((file) => /* @__PURE__ */ React27.createElement("td", { key: file, className: styles23.cell }, file))), RANK.map((rank, rowIndex) => /* @__PURE__ */ React27.createElement("tr", { key: rank }, /* @__PURE__ */ React27.createElement("td", { className: styles23.cell }, rank), FILE.map((_, colIndex) => {
    const isDark = (rowIndex + colIndex) % 2 === 0;
    const squareClass = isDark ? styles23.dark : styles23.light;
    return /* @__PURE__ */ React27.createElement(
      "td",
      {
        key: colIndex,
        className: cn(styles23.square, squareClass)
      },
      /* @__PURE__ */ React27.createElement("span", { className: styles23.symbol }, getPieceSymbol(board[rowIndex][colIndex]))
    );
  })))));
};
var Chessboard_default = Chessboard;

// components/CodeBlock.tsx
import styles24 from "./CodeBlock.module-7YQKULAB.module.css";
import * as React28 from "react";
var CodeBlock = React28.forwardRef(
  ({ children, ...rest }, ref) => {
    return /* @__PURE__ */ React28.createElement("pre", { className: styles24.root, ref, ...rest }, String(children).split("\n").map((line, index) => /* @__PURE__ */ React28.createElement("div", { key: index, className: styles24.line }, /* @__PURE__ */ React28.createElement("span", { className: styles24.number }, leftPad(String(index + 1), 3)), /* @__PURE__ */ React28.createElement("span", { className: styles24.content }, line))));
  }
);
CodeBlock.displayName = "CodeBlock";
var CodeBlock_default = CodeBlock;

// components/ComboBox.tsx
import styles26 from "./ComboBox.module-QY3JDKWJ.module.css";
import * as React30 from "react";

// components/Input.tsx
import * as React29 from "react";
import styles25 from "./Input.module-IY6HWGM5.module.css";
function Input({
  caretChars,
  isBlink = true,
  label,
  placeholder,
  onChange,
  type,
  id,
  ...rest
}) {
  const generatedId = React29.useId();
  const inputId = id || generatedId;
  const inputRef = React29.useRef(null);
  const [text, setText] = React29.useState(
    rest.defaultValue?.toString() || rest.value?.toString() || ""
  );
  const [isFocused, setIsFocused] = React29.useState(false);
  const [selectionStart, setSelectionStart] = React29.useState(
    text.length
  );
  const lastFocusDirectionRef = React29.useRef(null);
  React29.useEffect(() => {
    if (rest.value !== void 0) {
      const val = rest.value.toString();
      setText(val);
      setSelectionStart(val.length);
    }
  }, [rest.value]);
  const onHandleChange = (e) => {
    const value = e.target.value;
    setText(value);
    if (onChange) {
      onChange(e);
    }
    setSelectionStart(e.target.selectionStart ?? value.length);
  };
  const onHandleFocus = () => {
    setIsFocused(true);
    if (!inputRef.current) return;
    if (lastFocusDirectionRef.current === "down") {
      setSelectionStart(text.length);
      inputRef.current.setSelectionRange(text.length, text.length);
    } else if (lastFocusDirectionRef.current === "up") {
      setSelectionStart(0);
      inputRef.current.setSelectionRange(0, 0);
    }
  };
  const onHandleBlur = () => {
    setIsFocused(false);
  };
  const onHandleSelect = (e) => {
    const inputEl = e.currentTarget;
    setSelectionStart(inputEl.selectionStart ?? text.length);
  };
  const onHandleClick = (e) => {
    const inputEl = e.currentTarget;
    inputEl.focus();
    setSelectionStart(inputEl.selectionStart ?? text.length);
  };
  const onHandleKeyDown = (e) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      lastFocusDirectionRef.current = "up";
      const previousFocusable = findNextFocusable(
        document.activeElement,
        "previous"
      );
      previousFocusable?.focus();
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      lastFocusDirectionRef.current = "down";
      const nextFocusable = findNextFocusable(
        document.activeElement,
        "next"
      );
      nextFocusable?.focus();
    }
  };
  const isPlaceholderVisible = !text && placeholder;
  const containerClasses = cn(
    styles25.root,
    isFocused && styles25.focused
  );
  const maskText = (t) => type === "password" ? "\u2022".repeat(t.length) : t;
  const beforeCaretText = isPlaceholderVisible ? placeholder ?? "" : maskText(text.substring(0, selectionStart));
  const afterCaretText = isPlaceholderVisible ? "" : maskText(text.substring(selectionStart));
  return /* @__PURE__ */ React29.createElement("div", { className: containerClasses }, label && /* @__PURE__ */ React29.createElement("label", { htmlFor: inputId, className: styles25.label }, label), /* @__PURE__ */ React29.createElement("div", { className: styles25.inputContainer }, /* @__PURE__ */ React29.createElement(
    "div",
    {
      className: cn(
        styles25.displayed,
        isPlaceholderVisible && styles25.placeholder
      )
    },
    beforeCaretText,
    !isPlaceholderVisible && /* @__PURE__ */ React29.createElement(
      "span",
      {
        className: cn(styles25.block, isBlink && styles25.blink)
      },
      caretChars || ""
    ),
    !isPlaceholderVisible && afterCaretText
  ), /* @__PURE__ */ React29.createElement(
    "input",
    {
      id: inputId,
      ref: inputRef,
      className: styles25.hidden,
      value: text,
      "aria-placeholder": placeholder,
      type,
      onFocus: onHandleFocus,
      onBlur: onHandleBlur,
      onChange: onHandleChange,
      onSelect: onHandleSelect,
      onClick: onHandleClick,
      onKeyDown: onHandleKeyDown,
      ...rest
    }
  )));
}
var Input_default = Input;

// components/ComboBox.tsx
function ComboBox({ data, label }) {
  const [searchTerm, setSearchTerm] = React30.useState("");
  const filtered = React30.useMemo(() => {
    const sliced = data.slice(1);
    if (!searchTerm) return [];
    return sliced.filter(
      (entry) => entry[0].toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [data, searchTerm]);
  const displayed = React30.useMemo(() => {
    const sliced = data.slice(1);
    if (filtered.length >= 5) return filtered.slice(0, 5);
    if (filtered.length === 0 && searchTerm) return sliced.slice(0, 5);
    if (filtered.length > 0 && filtered.length < 5) {
      const needed = 5 - filtered.length;
      const remainder = sliced.filter((entry) => !filtered.includes(entry));
      return [...filtered, ...remainder.slice(0, needed)];
    }
    return sliced.slice(0, 5);
  }, [filtered, data, searchTerm]);
  const handleChange = React30.useCallback(
    (e) => {
      setSearchTerm(e.target.value);
    },
    []
  );
  return /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement("div", { className: styles26.root }, /* @__PURE__ */ React30.createElement(
    Input_default,
    {
      autoComplete: "off",
      isBlink: true,
      label,
      name: "input_test_blink",
      value: searchTerm,
      onChange: handleChange
    }
  )), displayed.map((entry) => /* @__PURE__ */ React30.createElement(CardDouble_default, { key: entry[0], title: entry[0] }, /* @__PURE__ */ React30.createElement(AlertBanner_default, null, entry[1]), /* @__PURE__ */ React30.createElement("br", null), /* @__PURE__ */ React30.createElement(
    ButtonGroup_default,
    {
      isFull: true,
      items: [
        { body: "FAVORITE" },
        { body: "DONATE" },
        { body: "LEARN MORE" }
      ]
    }
  ))));
}
var ComboBox_default = ComboBox;

// components/ContentFluid.tsx
import styles27 from "./ContentFluid.module-4DLC6WET.module.css";
import * as React31 from "react";
var ContentFluid = ({ children, ...rest }) => {
  return /* @__PURE__ */ React31.createElement("div", { className: styles27.root }, children);
};
var ContentFluid_default = ContentFluid;

// components/DataTable.tsx
import styles28 from "./DataTable.module-5QHMXXBG.module.css";
import * as React32 from "react";
var BASE_FOREGROUND_RGBA = { r: 98, g: 98, b: 98, a: 0.5 };
var BASE_BACKGROUND_RGBA = { r: 168, g: 168, b: 168, a: 0.5 };
var ALPHA = 0.45;
function interpolateColor(color1, color2, factor) {
  return {
    r: Math.round(color1.r + factor * (color2.r - color1.r)),
    g: Math.round(color1.g + factor * (color2.g - color1.g)),
    b: Math.round(color1.b + factor * (color2.b - color1.b)),
    a: color1.a + factor * (color2.a - color1.a)
  };
}
var DataTable = ({ data }) => {
  const tableRef = React32.useRef(null);
  const prevDataRef = React32.useRef(data);
  React32.useEffect(() => {
    const rows = tableRef.current?.querySelectorAll("tr") || [];
    for (let i = 1; i < data.length; i++) {
      const cells = rows[i]?.querySelectorAll("td");
      if (!cells) continue;
      for (let j = 0; j < data[i].length; j++) {
        const cell = cells[j];
        const changed = prevDataRef.current[i]?.[j] !== data[i][j];
        if (cell && changed) {
          cell.classList.remove(styles28.changed);
          void cell.offsetWidth;
          cell.classList.add(styles28.changed);
        }
      }
    }
    prevDataRef.current = data;
  }, [data]);
  const handleKeyDown = (event) => {
    const activeElement = document.activeElement;
    if (!activeElement) return;
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        if (activeElement instanceof HTMLTableCellElement) {
          activeElement.click();
        }
        break;
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowLeft":
      case "ArrowRight": {
        event.preventDefault();
        if (!(activeElement instanceof HTMLTableCellElement)) return;
        const direction = event.key === "ArrowUp" || event.key === "ArrowLeft" ? "previous" : "next";
        const allCells = Array.from(
          tableRef.current?.querySelectorAll("td") || []
        );
        const currentIndex = allCells.indexOf(activeElement);
        if (currentIndex === -1) return;
        let nextIndex = direction === "next" ? currentIndex + 1 : currentIndex - 1;
        if (direction === "previous") {
          if (nextIndex < 0) nextIndex = allCells.length - 1;
        } else {
          if (nextIndex >= allCells.length) nextIndex = 0;
        }
        allCells[nextIndex].focus();
        break;
      }
    }
  };
  const targetColorHeader = { r: 255, g: 255, b: 255, a: ALPHA };
  const targetColorData = { r: 255, g: 255, b: 255, a: ALPHA };
  return /* @__PURE__ */ React32.createElement("table", { className: styles28.root, ref: tableRef, onKeyDown: handleKeyDown }, /* @__PURE__ */ React32.createElement("tbody", { className: styles28.body }, data.map((row, rowIndex) => /* @__PURE__ */ React32.createElement(
    "tr",
    {
      key: rowIndex,
      className: styles28.row,
      tabIndex: 0,
      onClick: () => alert("testing")
    },
    row.map((cellContent, colIndex) => {
      let backgroundColor;
      if (rowIndex === 0) {
        const lightnessFactor = row.length > 1 ? colIndex / (row.length - 1) : 0;
        const newColor = interpolateColor(
          BASE_FOREGROUND_RGBA,
          targetColorHeader,
          lightnessFactor
        );
        backgroundColor = `rgba(${newColor.r}, ${newColor.g}, ${newColor.b}, ${newColor.a.toFixed(2)})`;
      } else {
        const numRows = data.length - 1;
        const maxIndexSum = numRows - 1 + (row.length - 1) || 1;
        const indexSum = rowIndex - 1 + colIndex;
        const lightnessFactor = indexSum / maxIndexSum;
        const newColor = interpolateColor(
          BASE_BACKGROUND_RGBA,
          targetColorData,
          lightnessFactor
        );
        backgroundColor = `rgba(${newColor.r}, ${newColor.g}, ${newColor.b}, ${newColor.a.toFixed(2)})`;
      }
      return /* @__PURE__ */ React32.createElement(
        "td",
        {
          key: colIndex,
          className: styles28.column,
          style: { backgroundColor }
        },
        cellContent
      );
    })
  ))));
};
var DataTable_default = DataTable;

// components/DatePicker.tsx
import styles29 from "./DatePicker.module-HUOUMR4Z.module.css";
import * as React33 from "react";
var WEEKDAYS = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
var MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var MAX_CELLS = 42;
var DatePicker = ({ year, month }) => {
  const today = /* @__PURE__ */ new Date();
  const [currentYear, setYear] = React33.useState(year || today.getFullYear());
  const [currentMonth, setMonth] = React33.useState(
    month || today.getMonth() + 1
  );
  const first = new Date(currentYear, currentMonth - 1, 1);
  const startingWeekday = first.getDay();
  const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
  const cells = [];
  for (let i = 0; i < startingWeekday; i++) {
    cells.push(/* @__PURE__ */ React33.createElement("div", { key: `empty-start-${i}`, className: styles29.dayCell }));
  }
  for (let day = 1; day <= daysInMonth; day++) {
    const presentationDay = String(day).padStart(2, "0");
    cells.push(
      /* @__PURE__ */ React33.createElement(
        "div",
        {
          key: day,
          className: styles29.cell,
          "aria-label": `${currentYear}-${String(currentMonth).padStart(2, "0")}-${presentationDay}`
        },
        presentationDay
      )
    );
  }
  while (cells.length < MAX_CELLS) {
    cells.push(
      /* @__PURE__ */ React33.createElement("div", { key: `empty-end-${cells.length}`, className: styles29.dayCell })
    );
  }
  const onSwitchPreviousMonth = () => {
    let newMonth = currentMonth - 1;
    let newYear = currentYear;
    if (newMonth < 1) {
      newMonth = 12;
      newYear--;
    }
    setMonth(newMonth);
    setYear(newYear);
  };
  const onSwitchNextMonth = () => {
    let newMonth = currentMonth + 1;
    let newYear = currentYear;
    if (newMonth > 12) {
      newMonth = 1;
      newYear++;
    }
    setMonth(newMonth);
    setYear(newYear);
  };
  return /* @__PURE__ */ React33.createElement("div", { className: styles29.root }, /* @__PURE__ */ React33.createElement("div", { className: styles29.controls }, /* @__PURE__ */ React33.createElement(
    "button",
    {
      type: "button",
      className: styles29.button,
      onClick: onSwitchPreviousMonth,
      "aria-label": "Previous month"
    },
    "\u25B2"
  ), /* @__PURE__ */ React33.createElement("div", { className: styles29.date }, currentYear, " ", MONTH_NAMES[currentMonth - 1].toUpperCase()), /* @__PURE__ */ React33.createElement(
    "button",
    {
      type: "button",
      className: styles29.button,
      onClick: onSwitchNextMonth,
      "aria-label": "Next month"
    },
    "\u25BC"
  )), /* @__PURE__ */ React33.createElement("div", { className: styles29.header }, WEEKDAYS.map((day) => /* @__PURE__ */ React33.createElement("div", { key: day, className: styles29.cell }, day))), /* @__PURE__ */ React33.createElement("div", { className: styles29.days }, cells));
};
var DatePicker_default = DatePicker;

// components/DebugGrid.tsx
import * as React34 from "react";
var DebugGrid = () => {
  React34.useEffect(() => {
    const debugGrid = document.createElement("div");
    let isVisible = false;
    const setGridHeight = () => {
      debugGrid.style.height = `${document.documentElement.scrollHeight}px`;
    };
    Object.assign(debugGrid.style, {
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      zIndex: "-1",
      margin: "0",
      backgroundImage: `
        repeating-linear-gradient(var(--theme-border) 0 1px, transparent 1px 100%),
        repeating-linear-gradient(90deg, var(--theme-border) 0 1px, transparent 1px 100%)
      `,
      backgroundSize: "1ch 1.25rem",
      pointerEvents: "none",
      display: "none"
    });
    document.body.appendChild(debugGrid);
    setGridHeight();
    const toggleDebugGrid = () => {
      isVisible = !isVisible;
      debugGrid.style.display = isVisible ? "block" : "none";
    };
    const handleDebugGridToggle = () => toggleDebugGrid();
    const observer = new ResizeObserver(() => {
      setGridHeight();
    });
    observer.observe(document.documentElement);
    window.addEventListener("debugGridToggle", handleDebugGridToggle);
    window.addEventListener("resize", setGridHeight);
    return () => {
      document.body.removeChild(debugGrid);
      window.removeEventListener("resize", setGridHeight);
      window.removeEventListener("debugGridToggle", handleDebugGridToggle);
      observer.disconnect();
    };
  }, []);
  return null;
};
var DebugGrid_default = DebugGrid;

// components/DefaultMetaTags.tsx
function DefaultMetaTags() {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("meta", { httpEquiv: "content-language", content: "en-us" }), /* @__PURE__ */ React.createElement(
    "meta",
    {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0, maximum-scale=1.0"
    }
  ), /* @__PURE__ */ React.createElement(
    "link",
    {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon-16x16.png"
    }
  ), /* @__PURE__ */ React.createElement(
    "link",
    {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon-32x32.png"
    }
  ), /* @__PURE__ */ React.createElement("link", { rel: "shortcut icon", href: "/favicon.ico" }));
}

// components/Dialog.tsx
import styles30 from "./Dialog.module-TBPZQNBH.module.css";
import * as React35 from "react";
var Dialog = ({
  title,
  children,
  style,
  onConfirm,
  onCancel
}) => {
  const titleId = React35.useId();
  const descId = React35.useId();
  return /* @__PURE__ */ React35.createElement(
    "div",
    {
      className: styles30.root,
      style,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": titleId,
      "aria-describedby": descId
    },
    /* @__PURE__ */ React35.createElement("header", { className: styles30.header }, title),
    /* @__PURE__ */ React35.createElement("br", null),
    /* @__PURE__ */ React35.createElement("article", { className: styles30.message, id: descId }, children),
    /* @__PURE__ */ React35.createElement("br", null),
    /* @__PURE__ */ React35.createElement("div", { className: styles30.actions }, /* @__PURE__ */ React35.createElement(Button_default, { theme: "SECONDARY", onClick: onConfirm }, "OK"), /* @__PURE__ */ React35.createElement(Block_default, { style: { opacity: 0 } }), /* @__PURE__ */ React35.createElement(Button_default, { theme: "SECONDARY", onClick: onCancel }, "Cancel")),
    /* @__PURE__ */ React35.createElement("br", null)
  );
};
var Dialog_default = Dialog;

// components/Divider.tsx
import styles31 from "./Divider.module-E4JLMLIG.module.css";
import * as React36 from "react";
var Divider = ({ children, style, type }) => {
  if (type === "GRADIENT") {
    return /* @__PURE__ */ React36.createElement("div", { className: styles31.gradient, style });
  }
  if (type === "DOUBLE") {
    return /* @__PURE__ */ React36.createElement("div", { className: styles31.divider, style }, /* @__PURE__ */ React36.createElement("div", { className: styles31.line, style: { marginBottom: "2px" } }), /* @__PURE__ */ React36.createElement("div", { className: styles31.line }));
  }
  return /* @__PURE__ */ React36.createElement("div", { className: styles31.divider, style }, /* @__PURE__ */ React36.createElement("div", { className: styles31.line }));
};
var Divider_default = Divider;

// components/DOMSnake.tsx
import { useEffect as useEffect13, useRef as useRef13, useState as useState16 } from "react";
import styles32 from "./DOMSnake.module-7XIADML4.module.css";
var DIRECTIONS = {
  ArrowUp: { x: 0, y: -1 },
  ArrowDown: { x: 0, y: 1 },
  ArrowLeft: { x: -1, y: 0 },
  ArrowRight: { x: 1, y: 0 }
};
function SnakeGame(props) {
  const GRID_WIDTH = props.width || 40;
  const GRID_HEIGHT = props.height || 20;
  const START_SPEED = props.startSpeed || 150;
  const INITIAL_SNAKE = [
    { x: Math.floor(GRID_WIDTH / 2), y: Math.floor(GRID_HEIGHT / 2) }
  ];
  const [snake, setSnake] = useState16(INITIAL_SNAKE);
  const [food, setFood] = useState16(null);
  const [direction, setDirection] = useState16(DIRECTIONS.ArrowRight);
  const [isGameOver, setIsGameOver] = useState16(false);
  const [speed, setSpeed] = useState16(START_SPEED);
  const moveInterval = useRef13(null);
  const nextDirection = useRef13(DIRECTIONS.ArrowRight);
  const gameContainerRef = useRef13(null);
  useEffect13(() => {
    setFood(generateFood());
  }, []);
  useEffect13(() => {
    if (gameContainerRef.current) {
      gameContainerRef.current.tabIndex = 0;
      gameContainerRef.current.focus();
    }
  }, []);
  const onHandleClick = (keyName) => {
    if (DIRECTIONS[keyName] && (DIRECTIONS[keyName].x !== -direction.x || DIRECTIONS[keyName].y !== -direction.y)) {
      nextDirection.current = DIRECTIONS[keyName];
    }
  };
  useEffect13(() => {
    const handleKeyDown = (e) => {
      if (!gameContainerRef.current?.contains(document.activeElement)) {
        gameContainerRef.current?.focus();
      }
      e.preventDefault();
      e.stopPropagation();
      if (DIRECTIONS[e.key] && (DIRECTIONS[e.key].x !== -direction.x || DIRECTIONS[e.key].y !== -direction.y)) {
        nextDirection.current = DIRECTIONS[e.key];
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [direction]);
  useEffect13(() => {
    if (isGameOver) return;
    if (moveInterval.current) clearInterval(moveInterval.current);
    moveInterval.current = setInterval(moveSnake, speed);
    return () => {
      if (moveInterval.current) clearInterval(moveInterval.current);
    };
  }, [snake, isGameOver, speed]);
  useEffect13(() => {
    restartGame();
  }, [isGameOver]);
  function moveSnake() {
    setDirection(nextDirection.current);
    const newHead = {
      x: snake[0].x + nextDirection.current.x,
      y: snake[0].y + nextDirection.current.y
    };
    if (checkCollision(newHead)) {
      setIsGameOver(true);
      return;
    }
    const newSnake = [newHead, ...snake];
    if (food && newHead.x === food.x && newHead.y === food.y) {
      setFood(generateFood());
      setSpeed((prev) => Math.max(prev - 5, 50));
    } else {
      newSnake.pop();
    }
    setSnake(newSnake);
  }
  function checkCollision({ x, y }) {
    return x < 0 || x >= GRID_WIDTH || y < 0 || y >= GRID_HEIGHT || snake.some((segment) => segment.x === x && segment.y === y);
  }
  function generateFood() {
    let newFood;
    do {
      newFood = {
        x: Math.floor(Math.random() * GRID_WIDTH),
        y: Math.floor(Math.random() * GRID_HEIGHT)
      };
    } while (snake.some(
      (segment) => segment.x === newFood.x && segment.y === newFood.y
    ));
    return newFood;
  }
  function restartGame() {
    setSnake(INITIAL_SNAKE);
    setFood(generateFood());
    setDirection(DIRECTIONS.ArrowRight);
    setSpeed(START_SPEED);
    nextDirection.current = DIRECTIONS.ArrowRight;
    setIsGameOver(false);
  }
  return /* @__PURE__ */ React.createElement("div", { className: styles32.container }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ActionButton_default, { hotkey: "\u2191", onClick: () => onHandleClick("ArrowUp") }, "Up"), /* @__PURE__ */ React.createElement(ActionButton_default, { hotkey: "\u2193", onClick: () => onHandleClick("ArrowDown") }, "Down"), /* @__PURE__ */ React.createElement(ActionButton_default, { hotkey: "\u2190", onClick: () => onHandleClick("ArrowLeft") }, "Left"), /* @__PURE__ */ React.createElement(ActionButton_default, { hotkey: "\u2192", onClick: () => onHandleClick("ArrowRight") }, "Right")), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles32.grid,
      ref: gameContainerRef,
      style: {
        gridTemplateColumns: `repeat(${GRID_WIDTH}, 10px)`,
        gridTemplateRows: `repeat(${GRID_HEIGHT}, 20px)`
      }
    },
    Array.from({ length: GRID_WIDTH * GRID_HEIGHT }).map(
      (_, i) => {
        const x = i % GRID_WIDTH;
        const y = Math.floor(i / GRID_WIDTH);
        const isSnake = snake.some(
          (segment) => segment.x === x && segment.y === y
        );
        const isFood = food ? food.x === x && food.y === y : false;
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            key: i,
            className: `${styles32.cell} ${isSnake ? styles32.snake : ""} ${isFood ? styles32.food : ""}`
          }
        );
      }
    )
  ));
}

// components/Drawer.tsx
import styles33 from "./Drawer.module-2MUHMKJF.module.css";
import * as React37 from "react";
var Drawer = ({
  children,
  defaultValue = false,
  ...rest
}) => {
  const [expand, setExpand] = React37.useState(defaultValue);
  return /* @__PURE__ */ React37.createElement("div", { className: styles33.root, ...rest }, expand ? /* @__PURE__ */ React37.createElement("div", { className: styles33.side }, children) : null, /* @__PURE__ */ React37.createElement("div", { className: styles33.right }, /* @__PURE__ */ React37.createElement("button", { className: styles33.action, onClick: () => setExpand(!expand) }, expand ? "\u2B60" : "\u2B62")));
};
var Drawer_default = Drawer;

// components/Grid.tsx
import styles34 from "./Grid.module-XYEW72LZ.module.css";
import * as React38 from "react";
var Grid = ({ children, ...rest }) => {
  return /* @__PURE__ */ React38.createElement("div", { className: styles34.grid, ...rest }, children);
};
var Grid_default = Grid;

// components/HoverComponentTrigger.tsx
import styles37 from "./HoverComponentTrigger.module-4KAFNKHW.module.css";
import * as React41 from "react";

// components/Popover.tsx
import styles35 from "./Popover.module-F63HQBKN.module.css";
import * as React39 from "react";
var Popover = React39.forwardRef(
  ({ style: propStyle, ...rest }, ref) => {
    const style = { ...propStyle };
    return /* @__PURE__ */ React39.createElement("div", { ref, className: styles35.root, ...rest, style });
  }
);
Popover.displayName = "Popover";
var Popover_default = Popover;

// components/Tooltip.tsx
import styles36 from "./Tooltip.module-DVYIAIUF.module.css";
import * as React40 from "react";
var Tooltip = React40.forwardRef(
  ({ style: propStyle, ...rest }, ref) => {
    const style = { ...propStyle };
    return /* @__PURE__ */ React40.createElement("div", { ref, className: styles36.root, ...rest, style });
  }
);
Tooltip.displayName = "Tooltip";
var Tooltip_default = Tooltip;

// components/HoverComponentTrigger.tsx
import { createPortal as createPortal2 } from "react-dom";
function HoverComponentTrigger({
  children,
  text,
  component
}) {
  const [open, setOpen] = React41.useState(false);
  const [placement, setPlacement] = React41.useState("bottom");
  const [position, setPosition] = React41.useState(
    { top: 0, left: 0 }
  );
  const triggerRef = React41.useRef(null);
  const popoverRef = React41.useRef(null);
  const onMouseEnter = () => setOpen(true);
  const onClick = () => setOpen(true);
  const onHandleFocus = () => setOpen(true);
  const onOutsideEvent = () => setOpen(false);
  React41.useEffect(() => {
    if (!open || !triggerRef.current || !popoverRef.current) return;
    const updatePosition = () => {
      const { placement: placement2, position: position2 } = calculate(
        triggerRef.current,
        popoverRef.current
      );
      setPlacement(placement2);
      setPosition(position2);
    };
    updatePosition();
    const handleResizeOrScroll = () => updatePosition();
    const mutationObserver = new MutationObserver(() => updatePosition());
    mutationObserver.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });
    window.addEventListener("resize", handleResizeOrScroll);
    window.addEventListener("scroll", handleResizeOrScroll, true);
    return () => {
      window.removeEventListener("resize", handleResizeOrScroll);
      window.removeEventListener("scroll", handleResizeOrScroll, true);
      mutationObserver.disconnect();
    };
  }, [open]);
  const renderComponent = () => {
    if (component === "popover") {
      return /* @__PURE__ */ React41.createElement(
        Popover_default,
        {
          ref: popoverRef,
          style: {
            position: "absolute",
            top: `${position.top}px`,
            left: `${position.left}px`,
            zIndex: "var(--z-index-page-popover)"
          },
          role: "dialog",
          "aria-modal": "true"
        },
        text
      );
    }
    if (component === "tooltip") {
      return /* @__PURE__ */ React41.createElement(
        Tooltip_default,
        {
          ref: popoverRef,
          style: {
            position: "absolute",
            top: `${position.top}px`,
            left: `${position.left}px`,
            zIndex: "var(--z-index-page-tooltip)"
          }
        },
        text
      );
    }
    return null;
  };
  const popoverElement = open ? createPortal2(
    /* @__PURE__ */ React41.createElement(OutsideElementEvent_default, { onOutsideEvent }, renderComponent()),
    document.body
  ) : null;
  return /* @__PURE__ */ React41.createElement(
    "div",
    {
      ref: triggerRef,
      className: styles37.root,
      "data-detector-ignore": true,
      onMouseEnter,
      onClick,
      onFocus: onHandleFocus
    },
    React41.cloneElement(children, {
      tabIndex: 0
    }),
    popoverElement
  );
}
var HoverComponentTrigger_default = HoverComponentTrigger;

// components/Indent.tsx
import styles38 from "./Indent.module-JU64AQQQ.module.css";
import * as React42 from "react";
var Indent = ({ children, ...rest }) => {
  return /* @__PURE__ */ React42.createElement("div", { className: styles38.root, ...rest }, children);
};
var Indent_default = Indent;

// components/ListItem.tsx
import styles39 from "./ListItem.module-KIZCZMD4.module.css";
import * as React43 from "react";
var ListItem = ({ children }) => {
  const itemRef = React43.useRef(null);
  const handleKeyDown = (event) => {
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        itemRef.current?.click();
        break;
      case "ArrowUp":
      case "ArrowLeft": {
        event.preventDefault();
        const previousFocusable = findNextFocusable(
          document.activeElement,
          "previous"
        );
        previousFocusable?.focus();
        break;
      }
      case "ArrowDown":
      case "ArrowRight": {
        event.preventDefault();
        const nextFocusable = findNextFocusable(
          document.activeElement,
          "next"
        );
        nextFocusable?.focus();
        break;
      }
      default:
        break;
    }
  };
  return /* @__PURE__ */ React43.createElement("li", { className: styles39.root, ref: itemRef, onKeyDown: handleKeyDown }, children);
};
var ListItem_default = ListItem;

// components/MatrixLoader.tsx
import styles40 from "./MatrixLoader.module-OQBTGXQZ.module.css";
import * as React44 from "react";
var LINE_HEIGHT3 = 20;
var CHARACTER_WIDTH3 = 9.6;
function onTextGeneration({ mode = "greek" }) {
  if (mode === "greek") {
    const isUppercase = Math.random() < 0.5;
    return String.fromCharCode(
      isUppercase ? 913 + Math.floor(Math.random() * (937 - 913 + 1)) : 945 + Math.floor(Math.random() * (969 - 945 + 1))
    );
  }
  if (mode === "katakana") {
    const japaneseRanges = [{ start: 12448, end: 12543 }];
    const allJapaneseCharacters = japaneseRanges.flatMap(
      (range) => Array.from(
        { length: range.end - range.start + 1 },
        (_, i) => range.start + i
      )
    );
    const randomJapaneseCharacter = allJapaneseCharacters[Math.floor(Math.random() * allJapaneseCharacters.length)];
    return String.fromCharCode(randomJapaneseCharacter);
  }
  return "0";
}
var MatrixLoader = ({
  rows = 25,
  direction = "top-to-bottom",
  mode = "greek"
}) => {
  const canvasRef = React44.useRef(null);
  React44.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const parent = canvas.parentElement;
    if (!parent) return;
    const resizeCanvas = () => {
      const parentWidth = parent.clientWidth;
      const parentHeight = rows * LINE_HEIGHT3;
      const dpr = window.devicePixelRatio || 1;
      canvas.style.width = `${parentWidth}px`;
      canvas.style.height = `${parentHeight}px`;
      canvas.width = Math.floor(parentWidth * dpr);
      canvas.height = Math.floor(parentHeight * dpr);
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.scale(dpr, dpr);
      }
    };
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);
    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  }, [rows]);
  React44.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    let interval;
    const drawMatrix = () => {
      const w = canvas.width;
      const h = canvas.height;
      if (direction === "top-to-bottom") {
        const cols = Math.floor(w / CHARACTER_WIDTH3);
        const ypos = Array(cols).fill(0);
        const matrix = () => {
          const themeTextColor = getComputedStyle(document.body).getPropertyValue("--theme-text").trim();
          const fontFamily = getComputedStyle(document.body).getPropertyValue("--font-family-mono").trim();
          ctx.globalCompositeOperation = "destination-out";
          ctx.fillStyle = "rgba(255, 255, 255, 0.05)";
          ctx.fillRect(0, 0, w, h);
          ctx.textBaseline = "top";
          ctx.font = `16px ${fontFamily}`;
          ctx.globalCompositeOperation = "source-over";
          ypos.forEach((y, ind) => {
            const text = onTextGeneration({ mode });
            const x = ind * CHARACTER_WIDTH3;
            ctx.fillStyle = themeTextColor;
            ctx.fillText(text, x, y);
            if (y > h + Math.random() * 1e4) {
              ypos[ind] = 0;
            } else {
              ypos[ind] = y + LINE_HEIGHT3;
            }
          });
        };
        interval = window.setInterval(matrix, 50);
      } else if (direction === "left-to-right") {
        const totalRows = rows;
        const xpos = Array(totalRows).fill(0);
        const matrix = () => {
          const themeTextColor = getComputedStyle(document.body).getPropertyValue("--theme-text").trim();
          const fontFamily = getComputedStyle(document.body).getPropertyValue("--font-family-mono").trim();
          ctx.globalCompositeOperation = "destination-out";
          ctx.fillStyle = "rgba(255, 255, 255, 0.05)";
          ctx.fillRect(0, 0, w, h);
          ctx.textBaseline = "top";
          ctx.font = `16px ${fontFamily}`;
          ctx.globalCompositeOperation = "source-over";
          xpos.forEach((x, ind) => {
            const text = onTextGeneration({ mode });
            const y = ind * LINE_HEIGHT3;
            ctx.fillStyle = themeTextColor;
            ctx.fillText(text, x, y);
            if (x > w + Math.random() * 1e4) {
              xpos[ind] = 0;
            } else {
              xpos[ind] = x + CHARACTER_WIDTH3;
            }
          });
        };
        interval = window.setInterval(matrix, 50);
      }
    };
    drawMatrix();
    return () => {
      window.clearInterval(interval);
    };
  }, [rows, direction, mode]);
  return /* @__PURE__ */ React44.createElement("div", { className: styles40.container }, /* @__PURE__ */ React44.createElement("canvas", { className: styles40.root, ref: canvasRef }));
};
var MatrixLoader_default = MatrixLoader;

// components/Message.tsx
import styles41 from "./Message.module-RKWKK6EC.module.css";
function Message(props) {
  return /* @__PURE__ */ React.createElement("div", { className: styles41.message }, /* @__PURE__ */ React.createElement("div", { className: styles41.left }, /* @__PURE__ */ React.createElement("figure", { className: styles41.triangle })), /* @__PURE__ */ React.createElement("div", { className: styles41.right }, /* @__PURE__ */ React.createElement("div", { className: styles41.bubble }, props.children)));
}

// components/MessageViewer.tsx
import styles42 from "./MessageViewer.module-7D3GZCLS.module.css";
function MessageViewer(props) {
  return /* @__PURE__ */ React.createElement("div", { className: styles42.message }, /* @__PURE__ */ React.createElement("div", { className: styles42.left }, /* @__PURE__ */ React.createElement("div", { className: styles42.bubble }, props.children)), /* @__PURE__ */ React.createElement("div", { className: styles42.right }, /* @__PURE__ */ React.createElement("figure", { className: styles42.triangle })));
}

// components/ModalStack.tsx
import styles43 from "./ModalStack.module-IBB5IAVA.module.css";
import * as React45 from "react";
var ModalStack = () => {
  const { modalStack } = useModals();
  const totalModals = modalStack.length;
  return /* @__PURE__ */ React45.createElement("div", { className: styles43.root }, modalStack.map((modalState, index) => {
    const { key, component: ModalComponent, props } = modalState;
    const offsetFromLast = totalModals - 1 - index;
    const translateY = -offsetFromLast * 40;
    const blur = offsetFromLast * 1.1;
    return /* @__PURE__ */ React45.createElement(
      "div",
      {
        key,
        className: styles43.item,
        style: {
          zIndex: 10 + index,
          transform: `translateY(${translateY}px)`,
          filter: `blur(${blur}px)`
        }
      },
      /* @__PURE__ */ React45.createElement(ModalComponent, { ...props })
    );
  }));
};
var ModalStack_default = ModalStack;

// components/Navigation.tsx
import styles44 from "./Navigation.module-RFDAXO46.module.css";
import * as React46 from "react";
var Navigation = ({
  children,
  logoHref,
  logoTarget,
  onClickLogo,
  logo,
  left,
  right
}) => {
  let logoElement = /* @__PURE__ */ React46.createElement("button", { className: styles44.logo }, logo);
  if (onClickLogo) {
    logoElement = /* @__PURE__ */ React46.createElement("button", { className: styles44.logo, onClick: onClickLogo }, logo);
  }
  if (logoHref) {
    logoElement = /* @__PURE__ */ React46.createElement("a", { href: logoHref, className: styles44.logo, target: logoTarget }, logo);
  }
  return /* @__PURE__ */ React46.createElement("nav", { className: styles44.root }, logoElement, /* @__PURE__ */ React46.createElement("section", { className: styles44.left }, left), /* @__PURE__ */ React46.createElement("section", { className: styles44.children }, children), /* @__PURE__ */ React46.createElement("section", { className: styles44.right }, right));
};
var Navigation_default = Navigation;

// components/NumberRangeSlider.tsx
import styles45 from "./NumberRangeSlider.module-QTSZVRNL.module.css";
import * as React47 from "react";
var NumberRangeSlider = ({
  max = 5e3,
  min = 0,
  step = 1,
  value,
  onChange
}) => {
  const sliderRef = React47.useRef(null);
  const [displayValue, setDisplayValue] = React47.useState(value ?? 0);
  const maxDigits = max.toString().length;
  const padValue = (value2) => {
    return value2.toString().padStart(maxDigits, "0");
  };
  React47.useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.value = String(value);
    }
    setDisplayValue(value ?? 0);
  }, [value]);
  const scrub = (event) => {
    const value2 = Number.parseInt(event.target.value, 10);
    setDisplayValue(value2);
    onChange?.(value2);
  };
  return /* @__PURE__ */ React47.createElement("div", { className: styles45.root }, /* @__PURE__ */ React47.createElement("label", { className: styles45.left }, /* @__PURE__ */ React47.createElement("div", { className: styles45.amount }, padValue(displayValue))), /* @__PURE__ */ React47.createElement(
    "input",
    {
      className: styles45.slider,
      defaultValue: value,
      max,
      min,
      onChange: scrub,
      ref: sliderRef,
      step,
      tabIndex: 0,
      type: "range"
    }
  ));
};
var NumberRangeSlider_default = NumberRangeSlider;

// components/Providers.tsx
import * as React48 from "react";
var Providers = ({ children }) => {
  return /* @__PURE__ */ React48.createElement(ModalProvider, null, children);
};
var Providers_default = Providers;

// components/RadioButton.tsx
import styles46 from "./RadioButton.module-I2AUD7WR.module.css";
import * as React49 from "react";
var RadioButton = ({
  style,
  name,
  value,
  selected = false,
  onSelect,
  children
}) => {
  const radioId = `${name}-${value}-radio`;
  const [isFocused, setIsFocused] = React49.useState(false);
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);
  const handleKeyDown = (event) => {
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        onSelect?.(value);
        break;
      case "ArrowUp":
      case "ArrowLeft":
        event.preventDefault();
        findNextFocusable(
          document.activeElement,
          "previous"
        )?.focus();
        break;
      case "Tab":
      case "ArrowDown":
      case "ArrowRight":
        event.preventDefault();
        findNextFocusable(document.activeElement, "next")?.focus();
        break;
      default:
        break;
    }
  };
  const handleChange = () => {
    onSelect?.(value);
  };
  return /* @__PURE__ */ React49.createElement(
    "div",
    {
      className: cn(styles46.section, {
        [styles46.focused]: isFocused,
        [styles46.selected]: selected
      }),
      style
    },
    /* @__PURE__ */ React49.createElement(
      "input",
      {
        className: styles46.input,
        id: radioId,
        type: "radio",
        name,
        value,
        checked: selected,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        onChange: handleChange
      }
    ),
    /* @__PURE__ */ React49.createElement("div", { className: styles46.relative }, /* @__PURE__ */ React49.createElement("label", { className: styles46.figure, htmlFor: radioId }, selected ? /* @__PURE__ */ React49.createElement("span", { "aria-hidden": "true", className: styles46.dot }) : null)),
    /* @__PURE__ */ React49.createElement("div", { className: styles46.right }, "\xA0\xA0", children)
  );
};
var RadioButton_default = RadioButton;

// components/RadioButtonGroup.tsx
import * as React50 from "react";
var RadioButtonGroup = ({
  options,
  defaultValue = ""
}) => {
  const [selectedValue, setSelectedValue] = React50.useState(defaultValue);
  const handleSelect = (value) => {
    setSelectedValue(value);
  };
  return /* @__PURE__ */ React50.createElement(React50.Fragment, null, options.map((option) => /* @__PURE__ */ React50.createElement(
    RadioButton_default,
    {
      key: option.value,
      name: "example",
      value: option.value,
      selected: selectedValue === option.value,
      onSelect: handleSelect
    },
    option.label
  )));
};
var RadioButtonGroup_default = RadioButtonGroup;

// components/RowEllipsis.tsx
import styles47 from "./RowEllipsis.module-UZQVP72I.module.css";
import * as React51 from "react";
var RowEllipsis = React51.forwardRef(
  ({ children, ...rest }, ref) => {
    return /* @__PURE__ */ React51.createElement("section", { className: styles47.row, ref, ...rest }, children);
  }
);
RowEllipsis.displayName = "RowEllipsis";
var RowEllipsis_default = RowEllipsis;

// components/RowSpaceBetween.tsx
import styles48 from "./RowSpaceBetween.module-ZFA3AWJI.module.css";
import * as React52 from "react";
var RowSpaceBetween = React52.forwardRef(
  ({ children, ...rest }, ref) => {
    return /* @__PURE__ */ React52.createElement("section", { className: styles48.row, ref, ...rest }, children);
  }
);
RowSpaceBetween.displayName = "RowSpaceBetween";
var RowSpaceBetween_default = RowSpaceBetween;

// components/Select.tsx
import styles49 from "./Select.module-KGJYU2D6.module.css";
import * as React53 from "react";
var Select = ({
  name,
  options,
  placeholder,
  defaultValue = "",
  onChange
}) => {
  const [isOpen, setIsOpen] = React53.useState(false);
  const [index, setIndex] = React53.useState(-1);
  const [selectedValue, setSelectedValue] = React53.useState(defaultValue);
  const containerRef = React53.useRef(null);
  const handleOpen = () => {
    setIsOpen(true);
    const currentIndex = options.indexOf(selectedValue);
    setIndex(currentIndex >= 0 ? currentIndex : 0);
  };
  const handleClose = () => {
    setIsOpen(false);
    setIndex(-1);
    if (containerRef?.current) {
      containerRef.current?.focus();
    }
  };
  const handleSelect = (value) => {
    setSelectedValue(value);
    onChange?.(value);
    handleClose();
  };
  return /* @__PURE__ */ React53.createElement(React53.Fragment, null, /* @__PURE__ */ React53.createElement("section", { className: styles49.select }, /* @__PURE__ */ React53.createElement(
    "figure",
    {
      className: cn(
        isOpen ? styles49.focused : null,
        styles49.control
      ),
      onClick: () => {
        isOpen ? handleClose() : handleOpen();
      }
    },
    "\u25BC"
  ), /* @__PURE__ */ React53.createElement(
    "button",
    {
      className: styles49.display,
      type: "button",
      ref: containerRef,
      tabIndex: 0,
      onClick: () => {
        isOpen ? handleClose() : handleOpen();
      },
      "aria-haspopup": "listbox",
      "aria-expanded": isOpen
    },
    selectedValue || placeholder
  )), isOpen && /* @__PURE__ */ React53.createElement("ul", { className: styles49.menu }, options.map((option, idx) => {
    return /* @__PURE__ */ React53.createElement(
      "li",
      {
        key: option,
        className: cn(styles49.item),
        onClick: () => handleSelect(option)
      },
      option
    );
  })));
};
var Select_default = Select;

// components/SidebarLayout.tsx
import styles50 from "./SidebarLayout.module-4F6U3GK5.module.css";
import * as React54 from "react";
var CHARACTER_WIDTH4 = 9.6;
var SidebarLayout = ({
  defaultSidebarWidth = 20,
  children,
  sidebar,
  isShowingHandle = false,
  isReversed = false,
  ...rest
}) => {
  const [sidebarWidth, setSidebarWidth] = React54.useState(defaultSidebarWidth);
  const handleRef = React54.useRef(null);
  const handleMouseDown = (event) => {
    const startX = event.clientX;
    const startWidth = sidebarWidth;
    const onMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - startX;
      const increment = Math.round(deltaX / CHARACTER_WIDTH4);
      setSidebarWidth(Math.max(CHARACTER_WIDTH4, startWidth + increment));
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };
  if (isReversed) {
    return /* @__PURE__ */ React54.createElement("div", { className: styles50.root, ...rest }, /* @__PURE__ */ React54.createElement("div", { className: styles50.content }, children), "\xA0", /* @__PURE__ */ React54.createElement(
      "div",
      {
        className: styles50.sidebar,
        style: {
          width: `${sidebarWidth}ch`
        }
      },
      sidebar
    ));
  }
  return /* @__PURE__ */ React54.createElement("div", { className: styles50.root, ...rest }, /* @__PURE__ */ React54.createElement(
    "div",
    {
      className: styles50.sidebar,
      style: {
        width: `${sidebarWidth}ch`
      }
    },
    sidebar
  ), isShowingHandle ? /* @__PURE__ */ React54.createElement(
    "div",
    {
      className: styles50.handle,
      ref: handleRef,
      role: "button",
      tabIndex: 0,
      onMouseDown: handleMouseDown,
      style: isShowingHandle ? {} : { width: "0.5ch" }
    },
    /* @__PURE__ */ React54.createElement(React54.Fragment, null, /* @__PURE__ */ React54.createElement("div", { className: styles50.line }), /* @__PURE__ */ React54.createElement("div", { className: styles50.line }))
  ) : null, /* @__PURE__ */ React54.createElement("div", { className: styles50.content }, children));
};
var SidebarLayout_default = SidebarLayout;

// components/Table.tsx
import styles51 from "./Table.module-BSUX6DZX.module.css";
import * as React55 from "react";
var Table = ({ children, ...rest }) => {
  return /* @__PURE__ */ React55.createElement("table", { className: styles51.root, ...rest }, /* @__PURE__ */ React55.createElement("tbody", { className: styles51.body }, children));
};
Table.displayName = "Table";
var Table_default = Table;

// components/TableColumn.tsx
import styles52 from "./TableColumn.module-HMBSP5PR.module.css";
import * as React56 from "react";
var TableColumn = ({ children, ...rest }) => {
  return /* @__PURE__ */ React56.createElement("td", { className: styles52.root, ...rest }, children);
};
TableColumn.displayName = "TableColumn";
var TableColumn_default = TableColumn;

// components/TableRow.tsx
import styles53 from "./TableRow.module-G4STESUX.module.css";
import * as React57 from "react";
var TableRow = ({ children, className, ...rest }) => {
  return /* @__PURE__ */ React57.createElement("tr", { className: cn(styles53.root, className), tabIndex: 0, ...rest }, children);
};
TableRow.displayName = "TableRow";
var TableRow_default = TableRow;

// components/Text.tsx
import styles54 from "./Text.module-ADRHGLS7.module.css";
import * as React58 from "react";
var Text = ({ children, ...rest }) => {
  return /* @__PURE__ */ React58.createElement("p", { className: styles54.text, ...rest }, children);
};
var Text_default = Text;

// components/TextArea.tsx
import styles55 from "./TextArea.module-WQ54OXKB.module.css";
import * as React59 from "react";
function TextArea({
  autoPlay,
  autoPlaySpeedMS = 40,
  isBlink,
  placeholder,
  onChange,
  ...rest
}) {
  const textAreaRef = React59.useRef(null);
  const measurementRef = React59.useRef(null);
  const [text, setText] = React59.useState(
    rest.defaultValue?.toString() || rest.value?.toString() || ""
  );
  const [isAutoPlaying, setIsAutoPlaying] = React59.useState(!!autoPlay);
  const [isFocused, setIsFocused] = React59.useState(false);
  const [selectionStart, setSelectionStart] = React59.useState(0);
  const autoPlayIntervalRef = React59.useRef(null);
  const autoPlayIndexRef = React59.useRef(0);
  const [currentLineIndex, setCurrentLineIndex] = React59.useState(0);
  const [totalLines, setTotalLines] = React59.useState(0);
  React59.useEffect(() => {
    if (textAreaRef.current && isFocused) {
      textAreaRef.current.setSelectionRange(selectionStart, selectionStart);
    }
  }, [selectionStart, isFocused]);
  React59.useEffect(() => {
    if (rest.value !== void 0) {
      const val = rest.value.toString();
      setText(val);
      setIsAutoPlaying(false);
      if (autoPlayIntervalRef.current) {
        clearInterval(autoPlayIntervalRef.current);
      }
      setSelectionStart(val.length);
    }
  }, [rest.value]);
  React59.useEffect(() => {
    if (autoPlay && !rest.value && !rest.defaultValue) {
      setIsAutoPlaying(true);
      autoPlayIndexRef.current = 0;
      setText("");
      if (autoPlayIntervalRef.current)
        clearInterval(autoPlayIntervalRef.current);
      autoPlayIntervalRef.current = setInterval(() => {
        autoPlayIndexRef.current++;
        if (!autoPlay) return;
        if (autoPlayIndexRef.current > autoPlay.length) {
          setIsAutoPlaying(false);
          clearInterval(autoPlayIntervalRef.current);
          return;
        }
        const newText = autoPlay.slice(0, autoPlayIndexRef.current);
        setText(newText);
        setSelectionStart(newText.length);
      }, autoPlaySpeedMS);
    }
    return () => {
      if (autoPlayIntervalRef.current)
        clearInterval(autoPlayIntervalRef.current);
    };
  }, [autoPlay, rest.value, rest.defaultValue]);
  const resizeTextArea = React59.useCallback(() => {
    if (!textAreaRef.current) return;
    textAreaRef.current.style.height = "auto";
    textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
  }, []);
  React59.useEffect(() => {
    resizeTextArea();
    window.addEventListener("resize", resizeTextArea);
    return () => window.removeEventListener("resize", resizeTextArea);
  }, [resizeTextArea]);
  const onHandleChange = (e) => {
    const value = e.target.value;
    setText(value);
    setIsAutoPlaying(false);
    if (autoPlayIntervalRef.current) {
      clearInterval(autoPlayIntervalRef.current);
    }
    resizeTextArea();
    if (onChange) {
      onChange(e);
    }
    setSelectionStart(e.target.selectionStart ?? 0);
  };
  const onHandleSelect = (e) => {
    const textarea = e.currentTarget;
    setSelectionStart(textarea.selectionStart);
  };
  const onHandleFocus = () => {
    setIsFocused(true);
    if (textAreaRef.current) {
      setSelectionStart(textAreaRef.current.selectionStart);
    }
  };
  const onHandleBlur = () => {
    setIsFocused(false);
  };
  const onHandleClick = (e) => {
    const textarea = e.currentTarget;
    textarea.focus();
    setSelectionStart(textarea.selectionStart);
  };
  React59.useLayoutEffect(() => {
    if (!measurementRef.current) return;
    const measurementEl = measurementRef.current;
    const computedStyle = window.getComputedStyle(measurementEl);
    const lineHeightStr = computedStyle.lineHeight;
    let lineHeight = 20;
    if (lineHeightStr.endsWith("px")) {
      lineHeight = Number.parseFloat(lineHeightStr);
    }
    const countLines = (content) => {
      measurementEl.textContent = content || "\xA0";
      const height = measurementEl.offsetHeight;
      return Math.round(height / lineHeight);
    };
    const displayString = text || placeholder || "";
    const textBeforeCaret = text.substring(0, selectionStart);
    const textAfterCaret = text.substring(selectionStart);
    const total = countLines(displayString);
    setTotalLines(total > 0 ? total - 1 : 0);
    const currentLines = countLines(textBeforeCaret);
    setCurrentLineIndex(currentLines > 0 ? currentLines - 1 : 0);
  }, [text, selectionStart, placeholder]);
  const onHandleKeyDown = (e) => {
    if (e.key === "ArrowUp" && currentLineIndex === 0) {
      e.preventDefault();
      const previousFocusable = findNextFocusable(
        document.activeElement,
        "previous"
      );
      previousFocusable?.focus();
    } else if (e.key === "ArrowDown" && currentLineIndex === totalLines) {
      e.preventDefault();
      const nextFocusable = findNextFocusable(
        document.activeElement,
        "next"
      );
      nextFocusable?.focus();
    }
  };
  const isPlaceholderVisible = !text && placeholder;
  const containerClasses = cn(
    styles55.root,
    isFocused && styles55.focused
  );
  return /* @__PURE__ */ React59.createElement("div", { className: containerClasses }, /* @__PURE__ */ React59.createElement(
    "div",
    {
      className: cn(
        styles55.displayed,
        isPlaceholderVisible && styles55.placeholder
      )
    },
    isPlaceholderVisible ? placeholder : text.substring(0, selectionStart),
    !isPlaceholderVisible && /* @__PURE__ */ React59.createElement(
      "span",
      {
        className: cn(styles55.block, isBlink && styles55.blink)
      }
    ),
    !isPlaceholderVisible && text.substring(selectionStart)
  ), /* @__PURE__ */ React59.createElement("div", { ref: measurementRef, className: styles55.hidden }), /* @__PURE__ */ React59.createElement(
    "textarea",
    {
      className: styles55.hiddenElement,
      ref: textAreaRef,
      value: text,
      "aria-placeholder": placeholder,
      onFocus: onHandleFocus,
      onBlur: onHandleBlur,
      onKeyDown: onHandleKeyDown,
      onChange: onHandleChange,
      onSelect: onHandleSelect,
      onClick: onHandleClick,
      ...rest
    }
  ));
}
var TextArea_default = TextArea;

// components/TreeView.tsx
import styles56 from "./TreeView.module-OXPIVSXG.module.css";
import * as React60 from "react";
var TreeView = ({
  defaultValue = false,
  title,
  children,
  depth = 0,
  isFile = false,
  isRoot = false,
  isLastChild = false,
  style,
  parentLines = []
}) => {
  const [show, setShow] = React60.useState(defaultValue);
  const onToggleShow = () => {
    if (!isFile) setShow((prevShow) => !prevShow);
  };
  const hasChildren = React60.Children.count(children) > 0;
  const isEmptyFolder = !isFile && !hasChildren;
  const spacing = parentLines.map((line) => line ? "\u2502 . " : ". . ").join("");
  const endPrefix = isLastChild ? "\u2514\u2500\u2500\u2500" : "\u251C\u2500\u2500\u2500";
  const prefix = `${spacing}${endPrefix}`;
  const icon = isFile ? " " : show ? "\u2566 " : "\u2564 ";
  const updatedParentLines = [...parentLines, !isLastChild];
  return /* @__PURE__ */ React60.createElement("div", { className: styles56.root, style }, /* @__PURE__ */ React60.createElement(
    "div",
    {
      tabIndex: 0,
      role: "button",
      onClick: onToggleShow,
      className: styles56.item,
      "aria-expanded": show
    },
    prefix,
    icon,
    title
  ), show && hasChildren && /* @__PURE__ */ React60.createElement("div", null, React60.Children.map(
    children,
    (child, index) => React60.isValidElement(child) ? React60.cloneElement(child, {
      depth: depth + 1,
      isLastChild: index === React60.Children.count(children) - 1,
      parentLines: updatedParentLines
    }) : child
  )));
};
var TreeView_default = TreeView;

// components/TableWithColumns.tsx
import * as React61 from "react";
import styles57 from "./TableWithColumns.module-SBWRUPHY.module.css";
var isVisibleInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
function TableWithColumns({
  columns,
  data,
  onClick,
  activeRowId,
  searchable = false,
  showVisitIcon = false,
  tabIndex = 0,
  autoFocus = false,
  filterLabel = "FILTER",
  showColumnNames = true,
  loading = false
}) {
  const [isSearchFocused, setIsSearchFocused] = React61.useState(false);
  const [search, setSearch] = React61.useState("");
  React61.useEffect(() => {
    if (activeRowId) {
      const rowElement = document.querySelector(`tr[data-id="${activeRowId}"]`);
      if (rowElement) {
        if (!isVisibleInViewport(rowElement)) {
          rowElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }
    }
  }, [activeRowId]);
  if (loading) {
    return /* @__PURE__ */ React61.createElement(BarLoader_default, { intervalRate: 100 });
  }
  return /* @__PURE__ */ React61.createElement("div", { className: "overflow-y-auto max-h-full" }, searchable && /* @__PURE__ */ React61.createElement("div", { className: "pb-4" }, /* @__PURE__ */ React61.createElement(
    Input_default,
    {
      autoFocus,
      autoComplete: "off",
      isBlink: isSearchFocused,
      onFocus: () => setIsSearchFocused(true),
      onBlur: () => setIsSearchFocused(false),
      onKeyDown: (e) => {
        if (e.key === "Escape" && searchable) {
          setSearch("");
        }
      },
      label: filterLabel,
      name: "search",
      value: search,
      onChange: (e) => setSearch(e.target.value)
    }
  )), /* @__PURE__ */ React61.createElement(Table_default, null, showColumnNames && !loading && data && data.length > 0 && /* @__PURE__ */ React61.createElement(TableRow_default, { tabIndex: -1, style: { opacity: 0.7 } }, columns.map((column) => /* @__PURE__ */ React61.createElement(TableColumn_default, { key: column.key, className: "text-left" }, /* @__PURE__ */ React61.createElement("span", { className: "uppercase opacity-50" }, column.name), /* @__PURE__ */ React61.createElement("br", null))), showVisitIcon && /* @__PURE__ */ React61.createElement(TableColumn_default, null)), !loading && !data?.length && /* @__PURE__ */ React61.createElement(TableRow_default, null, /* @__PURE__ */ React61.createElement(TableColumn_default, null, /* @__PURE__ */ React61.createElement("p", { className: "text-center uppercase opacity-50" }, "Empty :("))), !loading && data?.filter((item) => {
    return Object.values(item).some((value) => {
      if (value === null) {
        return false;
      }
      if (typeof value === "object" && value && "value" in value) {
        return value.value?.toString().toLowerCase().includes(search.toLowerCase());
      }
      return value?.toString().toLowerCase().includes(search.toLowerCase());
    });
  }).map((item) => /* @__PURE__ */ React61.createElement(
    TableRow_default,
    {
      key: item.id,
      tabIndex,
      onClick: () => onClick?.(item),
      "data-id": item.id,
      className: cn(styles57.row, {
        [styles57.active]: activeRowId === item.id,
        [styles57.inactive]: activeRowId !== item.id,
        [styles57.disabled]: !onClick,
        [styles57.clickable]: onClick
      })
    },
    columns.map((column) => {
      const columnValue = item[column.key];
      if (typeof columnValue === "object" && columnValue && "value" in columnValue && columnValue !== null) {
        return /* @__PURE__ */ React61.createElement(TableColumn_default, { key: column.key, className: "flex items-center gap-2" }, columnValue.icon && /* @__PURE__ */ React61.createElement("img", { src: columnValue.icon, alt: columnValue.value?.toString() ?? "", style: { width: "16px", height: "16px" } }), columnValue.value);
      } else {
        return /* @__PURE__ */ React61.createElement(TableColumn_default, { key: column.key, className: "p-0" }, columnValue);
      }
    }),
    showVisitIcon && /* @__PURE__ */ React61.createElement(TableColumn_default, null, /* @__PURE__ */ React61.createElement("button", { tabIndex: -1, style: { float: "right" } }, ">"))
  ))));
}
export {
  Accordion_default as Accordion,
  ActionBar_default as ActionBar,
  ActionButton_default as ActionButton,
  ActionListItem_default as ActionListItem,
  AlertBanner_default as AlertBanner,
  Avatar_default as Avatar,
  Badge_default as Badge,
  BarLoader_default as BarLoader,
  BarProgress_default as BarProgress,
  Block_default as Block,
  BlockLoader_default as BlockLoader,
  BreadCrumbs_default as BreadCrumbs,
  Button_default as Button,
  ButtonGroup_default as ButtonGroup,
  CanvasPlatformer_default as CanvasPlatformer,
  CanvasSnake_default as CanvasSnake,
  Card_default as Card,
  CardDouble_default as CardDouble,
  Checkbox_default as Checkbox,
  Chessboard_default as Chessboard,
  CodeBlock_default as CodeBlock,
  ComboBox_default as ComboBox,
  ContentFluid_default as ContentFluid,
  SnakeGame as DOMSnake,
  DataTable_default as DataTable,
  DatePicker_default as DatePicker,
  DebugGrid_default as DebugGrid,
  DefaultMetaTags,
  Dialog_default as Dialog,
  Divider_default as Divider,
  Drawer_default as Drawer,
  DropdownMenu_default as DropdownMenu,
  DropdownMenuTrigger_default as DropdownMenuTrigger,
  Grid_default as Grid,
  HotkeysProvider,
  HoverComponentTrigger_default as HoverComponentTrigger,
  Indent_default as Indent,
  Input_default as Input,
  ListItem_default as ListItem,
  MatrixLoader_default as MatrixLoader,
  Message,
  MessageViewer,
  ModalStack_default as ModalStack,
  ModalTrigger_default as ModalTrigger,
  Navigation_default as Navigation,
  NumberRangeSlider_default as NumberRangeSlider,
  Popover_default as Popover,
  Providers_default as Providers,
  RadioButton_default as RadioButton,
  RadioButtonGroup_default as RadioButtonGroup,
  Row_default as Row,
  RowEllipsis_default as RowEllipsis,
  RowSpaceBetween_default as RowSpaceBetween,
  Select_default as Select,
  SidebarLayout_default as SidebarLayout,
  Table_default as Table,
  TableColumn_default as TableColumn,
  TableRow_default as TableRow,
  TableWithColumns,
  Text_default as Text,
  TextArea_default as TextArea,
  Tooltip_default as Tooltip,
  TreeView_default as TreeView,
  bytesToSize,
  calculatePositionWithGutter,
  calculatePositionWithGutterById,
  classNames,
  cn,
  createSlug,
  debounce,
  deepEqual,
  elide,
  filterUndefined,
  findFocusableDescendant,
  findNextFocusable,
  formatDollars,
  generateNonce,
  getDomainFromEmailWithoutAnySubdomain,
  getOrdinalNumber,
  isEmpty,
  isFocusableElement,
  isHotkeyPressed,
  isUrl,
  leftPad,
  noop,
  onHandleFontChange,
  onHandleThemeChange,
  pluralize,
  timeAgo,
  toDateISOString,
  useGlobalNavigationHotkeys,
  useHotkeys,
  useHotkeysContext,
  useRecordHotkeys
};
//# sourceMappingURL=index.mjs.map